// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Create Flow Mode Notice */
.create-flow-notice {
  background: #e3f2fd;
  border: 1px solid #5ea1d8;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #1976d2;
}
.create-flow-notice .notice-icon {
  color: #5ea1d8;
  font-size: 18px;
  width: 18px;
  height: 18px;
}

/* Title Section */
.title-section {
  text-align: center;
  margin-bottom: 20px;
}
.title-section h2 {
  color: #333;
  margin-bottom: 8px;
  font-size: 24px;
  font-weight: 600;
}
.title-section p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

/* Search Section */
.search-section {
  margin-bottom: 20px;
}
.search-section .search-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}
.search-section .search-input:focus {
  border-color: #5ea1d8;
}
.search-section .search-input::placeholder {
  color: #999;
}

/* Users Section */
.users-section {
  margin-bottom: 20px;
}
.users-section .user-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s;
}
.users-section .user-item:hover {
  background-color: #f8f9fa;
}
.users-section .user-item .transfer-checkbox {
  margin-right: 16px;
}
.users-section .user-item .user-avatar {
  margin-right: 16px;
  cursor: pointer;
}
.users-section .user-item .user-avatar .avatar-image {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.users-section .user-item .user-avatar .avatar-placeholder {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.users-section .user-item .user-avatar .avatar-placeholder .material-icons {
  font-size: 24px;
  color: #666;
}
.users-section .user-item .user-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.users-section .user-item .user-info .user-name {
  font-weight: 600;
  color: #333;
  font-size: 16px;
}
.users-section .user-item .user-info .user-username {
  color: #666;
  font-size: 14px;
}
.users-section .user-item .user-info .user-email {
  color: #999;
  font-size: 12px;
}

/* Loading Section */
.loading-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  color: #666;
}
.loading-section mat-spinner {
  margin-right: 8px;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}
.action-buttons .cancel-btn {
  color: #666;
}
.action-buttons .confirm-btn {
  background-color: #5ea1d8;
  color: white;
}
.action-buttons .confirm-btn:disabled {
  background-color: #ccc;
  color: #666;
}

/* BASIC */
.Login {
  background-color: white;
}

.banner {
  margin-top: 200px;
}

html {
  background-color: #56baed;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
  border: 0.5px solid lightgrey;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  border-radius: 0 0 10px 10px;
}

/* TABS */
h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/
input[type=button],
input[type=submit],
input[type=reset] {
  background-color: #56baed;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  transition: all 0.3s ease-in-out;
}

input[type=button]:hover,
input[type=submit]:hover,
input[type=reset]:hover {
  background-color: #39ace7;
}

input[type=button]:active,
input[type=submit]:active,
input[type=reset]:active {
  transform: scale(0.95);
}

input[type=text],
input[type=password] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px 5px 5px 5px;
}

input[type=text]:focus,
input[type=password]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type=text]:placeholder,
input[type=password] {
  color: #cccccc;
}

/* ANIMATIONS */
/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  animation-name: fadeInDown;
  animation-duration: 1s;
  animation-fill-mode: both;
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}
/* Simple CSS3 Fade-in Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  opacity: 0;
  animation: fadeIn ease-in 1;
  animation-fill-mode: forwards;
  animation-duration: 1s;
}

.fadeIn.first {
  animation-delay: 0.4s;
}

.fadeIn.second {
  animation-delay: 0.6s;
  border: 0.5px solid lightgrey;
}

.fadeIn.third {
  animation-delay: 0.8s;
  border: 0.5px solid lightgrey;
}

.fadeIn.fourth {
  animation-delay: 1s;
  border: 0.5px solid lightgrey;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */
*:focus {
  outline: none;
}

#icon {
  width: 60%;
}

.mat-badge-content {
  background: #5ea1d8;
}

.example-form {
  min-width: 150px;
  max-width: 500px;
  width: 100%;
}

.example-full-width {
  width: 100%;
}

.img-div-left {
  position: fixed;
  z-index: 999;
  height: 150px;
  width: 150px;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.container {
  padding: 0px !important;
  max-height: 90vh;
  overflow-y: auto;
}

.box {
  max-width: 560px;
  width: 100% !important;
  margin: 10px;
  padding: 0px 25px;
  background: #fff !important;
  background-size: 50%;
  background-position: top center;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  background: "https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png";
  background-size: cover;
  background-position: center;
  border-radius: 15px 15px 0px 0px;
  margin: 0px auto;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-size: 100% 90%;
  background-position: top center;
  opacity: 1 !important;
  -webkit-backdrop-filter: none !important;
          backdrop-filter: none !important;
}

.box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

.box:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
}

.with-icon {
  text-align: left;
  height: 35px !important;
}
.with-icon img {
  margin: 0px !important;
}

.des-box {
  background: #fff;
  position: relative;
  width: 100%;
  background: #fff;
  position: relative;
}
.des-box > div > div mat-card {
  background: #f3f1f1 !important;
  background: #fff !important;
}
.des-box i {
  color: #212427 !important;
}

.des-box:after {
  content: "";
  width: 200%;
  height: 100vh;
  background: #fff;
  border-radius: 0px;
  position: absolute;
  top: 0px;
  z-index: -1;
  left: -50%;
  right: -50%;
}

.des-box:before {
  content: "";
  width: 200%;
  height: 40vh;
  background: #fff;
  border-radius: 100% 100% 0px 0px;
  position: absolute;
  top: -34px;
  z-index: -1;
  left: -50%;
  right: -50%;
}

.title-box {
  padding: 0px 0px 60px 0px;
  width: 100%;
}

.priceIcon-p {
  top: unset !important;
  bottom: 20px !important;
}

.title-div {
  border-bottom: 1px solid gray;
}

.title-box h2 {
  color: #fff !important;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 20px;
  text-align: left;
}

.title-box ul {
  margin: 0px;
  padding: 0px;
}

.title-box ul li {
  color: #fff;
  list-style: none;
  padding: 8px 10px 8px 0px;
  font-size: 16px;
  text-align: left;
}

.title-box ul li span {
  margin-right: 8px;
}

.footer-div {
  border-top: 1px solid gray;
  display: flex;
  justify-content: space-between;
}

.footer-div p {
  margin-top: 10px;
  margin-bottom: 0px;
}

p,
h5 {
  color: #212427 !important;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

h5 {
  font-size: 16px;
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 10px;
}

.close-ico {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #212427;
  opacity: 1 !important;
  z-index: 10;
  cursor: pointer;
  background: transparent;
  border: none;
}

.close-ico .close-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.code-div {
  height: 200px;
  overflow-y: scroll;
}

.input-container {
  position: relative;
  display: flex;
  height: 2.8rem;
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);
}

.input-container input {
  height: 100%;
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgb(176, 190, 197);
  padding: 0.625rem 70px 0.625rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: rgb(69, 90, 100);
  outline: none;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

.input-container input:focus {
  border: 1px solid #5ea1d8;
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.2);
}

.invite-btn {
  position: absolute;
  cursor: pointer;
  right: 4px;
  top: 4px;
  bottom: 4px;
  z-index: 10;
  border-radius: 4px;
  background-color: #5ea1d8;
  color: white;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
  vertical-align: middle;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border: none;
}

.invite-btn:hover {
  right: 2px;
  top: 2px;
  bottom: 2px;
  border-radius: 8px;
}

.input-container input:placeholder-shown ~ .invite-btn {
  pointer-events: none;
  background-color: #5ea1d8;
  opacity: 0.5;
}

form {
  display: flex;
  align-items: center;
}
form input {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px;
  outline: none !important;
  border: 0.5px solid lightgrey;
}

.parent-comment-box {
  background: #f3f1f1 !important;
  padding: 10px;
  max-height: 400px;
  overflow-y: scroll;
}

.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {
  background: #f8f8f8 !important;
  margin-left: 40px;
  margin-top: 10px;
}
.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment mat-card {
  padding: 10px;
}

@media (max-width: 767px) {
  p {
    flex-wrap: wrap;
  }
  .box {
    max-height: 100vh;
  }
  .des-box:after {
    height: 45vh;
  }
}
/* Ensure the dialog surface remains fully vivid and clickable like the comment popup */
::ng-deep .cdk-overlay-pane.dialoguebox .mat-mdc-dialog-container,
::ng-deep .cdk-overlay-pane.dialoguebox .mat-mdc-dialog-surface {
  opacity: 1 !important;
  pointer-events: auto !important;
  filter: none !important;
}

.box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

.popuptitle {
  text-align: left;
  font-size: 20px !important;
  padding-left: 15px;
}

.box:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
}

.with-icon {
  text-align: left;
  height: 35px !important;
}
.with-icon img {
  margin: 0px !important;
}

.des-box {
  background: #fff;
  position: relative;
  width: 100%;
  background: #fff;
  position: relative;
}
.des-box > div > div mat-card {
  background: #f3f1f1 !important;
  background: #fff !important;
  box-shadow: none !important;
}
.des-box i {
  color: #212427 !important;
}

.des-box:after {
  content: "";
  width: 200%;
  height: 100vh;
  background: #fff;
  border-radius: 0px !important;
  position: absolute;
  top: -100px;
  z-index: -1;
  left: -50%;
  right: -50%;
}

.title-box {
  padding: 0px 0px 80px 0px;
  display: none;
}

.title-div {
  border-bottom: 1px solid gray;
}

.title-box h2 {
  color: #fff !important;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 20px;
  text-align: left;
}

.title-box ul {
  margin: 0px;
  padding: 0px;
}

.title-box ul li {
  color: #fff;
  list-style: none;
  padding: 8px 10px 8px 0px;
  font-size: 16px;
  text-align: left;
}

.title-box ul li span {
  margin-right: 8px;
}

.footer-div {
  border-top: 1px solid gray;
  display: flex;
  justify-content: space-between;
}

.footer-div p {
  margin-top: 10px;
  margin-bottom: 0px;
}

p,
h5 {
  color: #212427 !important;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

h5 {
  font-size: 16px;
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 10px;
}

.close-ico {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #212427;
  opacity: 1 !important;
  z-index: 10;
  cursor: pointer;
  background: transparent;
  border: none;
}

.close-ico .close-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

.code-div {
  height: 200px;
  overflow-y: scroll;
}

.input-container {
  position: relative;
  display: flex;
  height: 2.8rem;
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);
}

.input-container input {
  height: 100%;
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgb(176, 190, 197);
  background-color: transparent;
  padding: 0.625rem 70px 0.625rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: rgb(69, 90, 100);
  outline: none;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

.input-container input:focus {
  border: 1px solid #5ea1d8;
  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.2);
}

.invite-btn {
  position: absolute;
  cursor: pointer;
  right: 4px;
  top: 4px;
  bottom: 4px;
  z-index: 10;
  border-radius: 4px;
  background-color: #5ea1d8;
  color: white;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
  vertical-align: middle;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border: none;
}

.invite-btn:hover {
  right: 2px;
  top: 2px;
  bottom: 2px;
  border-radius: 8px;
}

.input-container input:placeholder-shown ~ .invite-btn {
  pointer-events: none;
  background-color: #5ea1d8;
  opacity: 0.5;
}

form {
  display: flex;
  align-items: center;
}
form input {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px;
  outline: none !important;
  border: 0.5px solid lightgrey;
}

.parent-comment-box {
  background: #f3f1f1 !important;
  padding: 10px;
  max-height: 400px;
  overflow-y: scroll;
}

.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {
  background: #f8f8f8 !important;
  margin-left: 40px;
  margin-top: 10px;
}
.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment mat-card {
  padding: 10px;
}

@media (max-width: 767px) {
  p {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  p span {
    width: 100%;
    display: block;
  }
  .box {
    max-width: 95vw !important;
    width: 95vw !important;
    margin: 2.5vh auto !important;
    padding: 0px 15px !important;
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    max-height: 90vh !important;
  }
}
.ownership-warning {
  margin: 20px;
  text-align: left;
}
.ownership-warning .note-box {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  border-radius: 5px;
  padding: 15px;
  font-size: 14px;
}
.ownership-warning .note-list {
  margin: 10px 0;
  padding-left: 0;
  list-style: none;
}
.ownership-warning .note-list li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 8px;
}
.ownership-warning .note-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 6px;
  width: 8px;
  height: 8px;
  background-color: #856404;
  border-radius: 50%;
}
.ownership-warning .ownership-buttons {
  margin-top: 15px;
}
.ownership-warning .ownership-buttons button + button {
  margin-left: 10px;
}

/* Comment Form Styling */
.comment-form-section {
  margin: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
.comment-form-section .example-form {
  margin: 0;
}
.comment-form-section .example-form .w-100 {
  width: 100%;
}
.comment-form-section .example-form .font16 {
  font-size: 16px;
  font-weight: 500;
  color: #495057;
}
.comment-form-section .example-form mat-form-field {
  width: 100%;
  /* removed empty .mat-mdc-form-field-focus-overlay block to satisfy linter */
}
.comment-form-section .example-form mat-form-field .mat-mdc-form-field {
  width: 100%;
}
.comment-form-section .example-form mat-form-field .mat-mdc-text-field-wrapper {
  background-color: #fff;
  border-radius: 6px;
}
.comment-form-section .example-form mat-form-field input {
  font-size: 14px;
  color: #495057;
}
.comment-form-section .example-form mat-form-field input::placeholder {
  color: #6c757d;
  opacity: 0.7;
}
.comment-form-section .example-form mat-form-field .mat-mdc-form-field-hint {
  color: #6c757d;
  font-size: 12px;
}

.transfer-ownership-dialog {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  width: 100%;
  max-width: 600px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}
:host-context(body.theme-dark) .transfer-ownership-dialog {
  background: #1a1a1a;
  color: #ffffff;
}
@media (prefers-contrast: high) {
  .transfer-ownership-dialog {
    border: 2px solid #000000;
  }
}
@media (prefers-reduced-motion: reduce) {
  .transfer-ownership-dialog * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
.transfer-ownership-dialog .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
}
.transfer-ownership-dialog .dialog-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 2px;
  color: #333;
}
.transfer-ownership-dialog .dialog-header .header-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: #333;
}
.transfer-ownership-dialog .dialog-header .close-button {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  color: #666;
  transition: color 0.2s ease;
}
.transfer-ownership-dialog .dialog-header .close-button:hover {
  color: #333;
  background: transparent !important;
}
.transfer-ownership-dialog .dialog-header .close-button:focus {
  background: transparent !important;
  box-shadow: none !important;
}
.transfer-ownership-dialog .dialog-content {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 24px;
}
.transfer-ownership-dialog .dialog-content .search-section {
  margin-bottom: 24px;
}
.transfer-ownership-dialog .dialog-content .search-section .search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.transfer-ownership-dialog .dialog-content .search-section .search-input-wrapper .search-icon {
  position: absolute;
  left: 12px;
  color: #666;
  z-index: 1;
}
.transfer-ownership-dialog .dialog-content .search-section .search-input-wrapper .search-input {
  width: 100%;
  padding: 12px 12px 12px 44px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s ease;
}
.transfer-ownership-dialog .dialog-content .search-section .search-input-wrapper .search-input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);
}
.transfer-ownership-dialog .dialog-content .search-section .search-input-wrapper .search-input::placeholder {
  color: #999;
}
.transfer-ownership-dialog .dialog-content .users-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.transfer-ownership-dialog .dialog-content .users-section .section-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.transfer-ownership-dialog .dialog-content .users-section .section-header .pagination-info {
  font-size: 12px;
  color: #666;
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 12px;
}
.transfer-ownership-dialog .dialog-content .users-section .searching-users {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: #666;
}
.transfer-ownership-dialog .dialog-content .users-section .searching-users span {
  font-size: 14px;
}
.transfer-ownership-dialog .dialog-content .users-section .no-users {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: #999;
}
.transfer-ownership-dialog .dialog-content .users-section .no-users mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  opacity: 0.5;
}
.transfer-ownership-dialog .dialog-content .users-section .no-users span {
  font-size: 14px;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list {
  margin-bottom: 16px;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option {
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background-color 0.2s ease;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option:hover {
  background-color: #f8f9fa;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-avatar .avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-avatar .avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f5f5f5 0%, #f5f5f5 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-avatar .avatar-placeholder mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: white;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-info {
  flex: 1;
  min-width: 0;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-info .user-name {
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
  font-size: 14px;
}
.transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-info .user-email {
  color: #666;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn:disabled {
  opacity: 0.5;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 1;
  overflow: visible;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers {
  display: flex;
  gap: 4px;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers .page-btn {
  min-width: 32px;
  height: 32px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #e0e0e0;
  background: white;
  color: #666;
  transition: all 0.2s ease;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers .page-btn:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #ccc;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers .page-btn.active {
  background: #5ea1d8;
  color: white;
  border-color: #5ea1d8;
}
.transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers .page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.transfer-ownership-dialog .dialog-content .selected-user-section {
  margin-bottom: 24px;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-header .change-user-btn {
  color: #5ea1d8;
  font-size: 12px;
  padding: 4px 8px;
  min-height: 32px;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-header .change-user-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid #e9ecef;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-avatar .avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-avatar .avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f5f5f5 0%, #f5f5f5 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-avatar .avatar-placeholder mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
  color: white;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-info {
  flex: 1;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-info .user-name {
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  font-size: 16px;
}
.transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-info .user-email {
  color: #666;
  font-size: 14px;
}
.transfer-ownership-dialog .dialog-content .ownership-warning {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}
.transfer-ownership-dialog .dialog-content .ownership-warning .warning-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.transfer-ownership-dialog .dialog-content .ownership-warning .warning-header .warning-icon {
  color: #f39c12;
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.transfer-ownership-dialog .dialog-content .ownership-warning .warning-header h4 {
  margin: 0;
  color: #856404;
  font-size: 14px;
  font-weight: 600;
}
.transfer-ownership-dialog .dialog-content .ownership-warning p {
  margin: 0;
  color: #856404;
  font-size: 13px;
  line-height: 1.4;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .form-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .form-header .char-count {
  font-size: 12px;
  color: #666;
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 8px;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .comment-field {
  width: 100%;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .comment-field ::ng-deep .mat-form-field-wrapper {
  padding-bottom: 0;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .comment-field ::ng-deep .mat-form-field-outline {
  border-radius: 8px;
}
.transfer-ownership-dialog .dialog-content .comment-form-section .comment-field textarea {
  font-size: 14px;
  line-height: 1.4;
}
.transfer-ownership-dialog .dialog-actions {
  display: flex;
  gap: 12px;
  padding: 20px 24px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  position: sticky;
  bottom: 0;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  overflow-x: visible;
  overflow-y: hidden;
}
.transfer-ownership-dialog .dialog-actions .cancel-btn,
.transfer-ownership-dialog .dialog-actions .transfer-btn,
.transfer-ownership-dialog .dialog-actions .confirm-user-btn {
  height: 40px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 100px;
  flex: 0 1 auto;
}
.transfer-ownership-dialog .dialog-actions .cancel-btn mat-icon,
.transfer-ownership-dialog .dialog-actions .transfer-btn mat-icon,
.transfer-ownership-dialog .dialog-actions .confirm-user-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.transfer-ownership-dialog .dialog-actions .cancel-btn {
  background: white;
  color: #666;
  border: 1px solid #e0e0e0;
}
.transfer-ownership-dialog .dialog-actions .cancel-btn:hover {
  background: #f5f5f5;
  border-color: #ccc;
}
.transfer-ownership-dialog .dialog-actions .confirm-user-btn {
  background: #28a745;
  color: white;
  border: none;
}
.transfer-ownership-dialog .dialog-actions .confirm-user-btn:hover:not(:disabled) {
  background: #218838;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}
.transfer-ownership-dialog .dialog-actions .confirm-user-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.transfer-ownership-dialog .dialog-actions .transfer-btn {
  background: #5ea1d8;
  color: white;
  border: none;
}
.transfer-ownership-dialog .dialog-actions .transfer-btn:hover:not(:disabled) {
  background: #56baed;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);
}
.transfer-ownership-dialog .dialog-actions .transfer-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.transfer-ownership-dialog .progress-bar {
  height: 4px;
  border-radius: 0;
}

@media (max-width: 768px) {
  .transfer-ownership-dialog {
    max-height: 95vh !important;
    width: 95vw !important;
    max-width: 50vh !important;
    margin: 2.5vh auto !important;
    border-radius: 8px;
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    -webkit-overflow-scrolling: touch;
  }
  .transfer-ownership-dialog .dialog-header {
    padding: 16px 20px;
    min-height: 60px;
  }
  .transfer-ownership-dialog .dialog-header h2 {
    font-size: 18px;
    line-height: 1.3;
  }
  .transfer-ownership-dialog .dialog-header .close-button {
    min-width: 44px;
    min-height: 44px;
    padding: 8px;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }
  .transfer-ownership-dialog .dialog-content {
    padding: 20px;
    max-height: calc(95vh - 140px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .transfer-ownership-dialog .dialog-content .search-section {
    margin-bottom: 20px;
  }
  .transfer-ownership-dialog .dialog-content .search-section .search-input {
    min-height: 44px;
    font-size: 16px;
    padding: 12px 16px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 16px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .section-header .pagination-info {
    align-self: flex-end;
    font-size: 14px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .users-list .user-option {
    min-height: 60px;
    padding: 12px 16px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-avatar .avatar-image,
  .transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-avatar .avatar-placeholder {
    width: 48px;
    height: 48px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-info .user-name {
    font-size: 16px;
    line-height: 1.4;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls {
    margin-top: 16px;
    gap: 8px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn {
    min-width: 44px;
    min-height: 44px;
    padding: 8px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers {
    gap: 4px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers .page-btn {
    min-width: 44px;
    min-height: 44px;
    font-size: 14px;
    padding: 8px 12px;
  }
  .transfer-ownership-dialog .dialog-content .selected-user-section {
    margin-bottom: 20px;
  }
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 16px;
  }
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-header .change-user-btn {
    align-self: flex-end;
    min-height: 44px;
    padding: 8px 16px;
  }
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card {
    padding: 16px;
    border-radius: 8px;
    background: #f8f9fa;
  }
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-avatar .avatar-image,
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-avatar .avatar-placeholder {
    width: 56px;
    height: 56px;
  }
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-info .user-name {
    font-size: 18px;
    font-weight: 600;
  }
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-info .user-email {
    font-size: 14px;
    color: #666;
  }
  .transfer-ownership-dialog .dialog-content .ownership-warning {
    margin-bottom: 20px;
  }
  .transfer-ownership-dialog .dialog-content .ownership-warning .note-box {
    padding: 16px;
    border-radius: 8px;
    font-size: 14px;
    line-height: 1.5;
  }
  .transfer-ownership-dialog .dialog-content .ownership-warning .note-box .note-list {
    margin: 12px 0;
    padding-left: 20px;
  }
  .transfer-ownership-dialog .dialog-content .ownership-warning .note-box .note-list li {
    margin-bottom: 8px;
  }
  .transfer-ownership-dialog .dialog-content .comment-form-section .form-header {
    margin-bottom: 12px;
  }
  .transfer-ownership-dialog .dialog-content .comment-form-section .form-header h4 {
    font-size: 16px;
    margin-bottom: 8px;
  }
  .transfer-ownership-dialog .dialog-content .comment-form-section .form-header .char-count {
    font-size: 12px;
  }
  .transfer-ownership-dialog .dialog-content .comment-form-section .comment-field .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix textarea {
    min-height: 80px;
    font-size: 16px;
    line-height: 1.4;
  }
  .transfer-ownership-dialog .dialog-actions {
    padding: 16px 20px;
    min-height: 60px;
    position: sticky;
    bottom: 0;
    background: #f8f9fa;
    border-top: 1px solid #e0e0e0;
    display: flex;
    gap: 12px;
    justify-content: flex-end;
  }
  .transfer-ownership-dialog .dialog-actions .cancel-btn,
  .transfer-ownership-dialog .dialog-actions .transfer-btn,
  .transfer-ownership-dialog .dialog-actions .confirm-user-btn {
    min-height: 48px;
    min-width: 120px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    padding: 12px 20px;
  }
  .transfer-ownership-dialog .dialog-actions .cancel-btn mat-icon,
  .transfer-ownership-dialog .dialog-actions .transfer-btn mat-icon,
  .transfer-ownership-dialog .dialog-actions .confirm-user-btn mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
  .transfer-ownership-dialog .dialog-actions .cancel-btn {
    background: #f5f5f5;
    color: #666;
    border: 1px solid #ddd;
  }
  .transfer-ownership-dialog .dialog-actions .cancel-btn:hover {
    background: #e8e8e8;
  }
  .transfer-ownership-dialog .dialog-actions .transfer-btn,
  .transfer-ownership-dialog .dialog-actions .confirm-user-btn {
    background: #5ea1d8;
    color: white;
  }
  .transfer-ownership-dialog .dialog-actions .transfer-btn:hover:not(:disabled),
  .transfer-ownership-dialog .dialog-actions .confirm-user-btn:hover:not(:disabled) {
    background: #4a8bc2;
  }
  .transfer-ownership-dialog .dialog-actions .transfer-btn:disabled,
  .transfer-ownership-dialog .dialog-actions .confirm-user-btn:disabled {
    background: #ccc;
    color: #999;
  }
}
/* Final dark-mode override for transfer dialog text + surfaces */
:host-context(body.theme-dark) .box,
:host-context(body.theme-dark) .analytics-header,
:host-context(body.theme-dark) .analytics-content,
:host-context(body.theme-dark) .box-wrap,
:host-context(body.theme-dark) .des-box,
:host-context(body.theme-dark) .dialog-content,
:host-context(body.theme-dark) .dialog-actions,
:host-context(body.theme-dark) .selected-user-card {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .comment-form-section {
  background: transparent !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .dialog-actions {
  background: #0f172a !important;
}
:host-context(body.theme-dark) h2,
:host-context(body.theme-dark) h3,
:host-context(body.theme-dark) h4,
:host-context(body.theme-dark) p,
:host-context(body.theme-dark) span,
:host-context(body.theme-dark) label,
:host-context(body.theme-dark) small,
:host-context(body.theme-dark) .user-name,
:host-context(body.theme-dark) .user-email,
:host-context(body.theme-dark) .search-icon,
:host-context(body.theme-dark) .close-ico,
:host-context(body.theme-dark) .close-ico .close-icon,
:host-context(body.theme-dark) .header-icon,
:host-context(body.theme-dark) .pagination-info,
:host-context(body.theme-dark) .char-count {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .search-input,
:host-context(body.theme-dark) .search-input-wrapper .search-input,
:host-context(body.theme-dark) .input-container,
:host-context(body.theme-dark) .input-container input,
:host-context(body.theme-dark) input,
:host-context(body.theme-dark) textarea {
  background: #1f2937 !important;
  color: #f8fafc !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
}
:host-context(body.theme-dark) .comment-field textarea,
:host-context(body.theme-dark) .comment-field .mat-mdc-text-field-wrapper,
:host-context(body.theme-dark) .comment-field .mat-mdc-form-field-flex,
:host-context(body.theme-dark) .comment-field .mdc-text-field {
  background: transparent !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .users-list .user-option,
:host-context(body.theme-dark) .page-btn {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .users-list .user-option,
:host-context(body.theme-dark) .users-list mat-list-option {
  --mdc-list-list-item-hover-state-layer-color: rgba(94, 161, 216, 0.12);
  --mdc-list-list-item-focus-state-layer-color: rgba(94, 161, 216, 0.16);
  --mdc-list-list-item-hover-state-layer-opacity: 1;
  --mat-list-list-item-hover-state-layer-color: rgba(94, 161, 216, 0.12);
}
:host-context(body.theme-dark) .users-list .user-option:hover,
:host-context(body.theme-dark) .users-list .user-option:focus,
:host-context(body.theme-dark) .users-list mat-list-option:hover,
:host-context(body.theme-dark) .users-list mat-list-option:focus {
  background: rgba(94, 161, 216, 0.12) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .users-list .user-option .user-name,
:host-context(body.theme-dark) .users-list .user-option .user-email,
:host-context(body.theme-dark) .users-list mat-list-option .user-name,
:host-context(body.theme-dark) .users-list mat-list-option .user-email {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .selected-user-card {
  background: #1e3a4a !important;
  border-color: rgba(94, 161, 216, 0.4) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .selected-user-card .user-name {
  color: #f0f9ff !important;
}
:host-context(body.theme-dark) .selected-user-card .user-email {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .dialog-actions .cancel-btn {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.4) !important;
}
:host-context(body.theme-dark) .dialog-actions .cancel-btn span,
:host-context(body.theme-dark) .dialog-actions .cancel-btn .mdc-button__label,
:host-context(body.theme-dark) .dialog-actions .cancel-btn mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .dialog-actions .transfer-btn,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn {
  background: #5ea1d8 !important;
  border-color: #5ea1d8 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .dialog-actions .transfer-btn span,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn span,
:host-context(body.theme-dark) .dialog-actions .transfer-btn .mdc-button__label,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn .mdc-button__label,
:host-context(body.theme-dark) .dialog-actions .transfer-btn mat-icon,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn mat-icon {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .dialog-actions .transfer-btn:disabled,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn:disabled {
  background: #374151 !important;
  border-color: #374151 !important;
  color: #6b7280 !important;
}
:host-context(body.theme-dark) .dialog-actions .transfer-btn:disabled span,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn:disabled span,
:host-context(body.theme-dark) .dialog-actions .transfer-btn:disabled .mdc-button__label,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn:disabled .mdc-button__label,
:host-context(body.theme-dark) .dialog-actions .transfer-btn:disabled mat-icon,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn:disabled mat-icon {
  color: #6b7280 !important;
}
:host-context(body.theme-dark) .ownership-warning,
:host-context(body.theme-dark) .ownership-warning .note-box {
  background: rgba(120, 53, 15, 0.3) !important;
  color: #fde68a !important;
  border-color: rgba(251, 191, 36, 0.45) !important;
}

/* Final dark override (must stay at file end). */
:host-context(body.theme-dark) .box,
:host-context(body.theme-dark) .analytics-header,
:host-context(body.theme-dark) .analytics-content,
:host-context(body.theme-dark) .box-wrap,
:host-context(body.theme-dark) .des-box,
:host-context(body.theme-dark) .dialog-content,
:host-context(body.theme-dark) .dialog-actions,
:host-context(body.theme-dark) .selected-user-card {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .comment-form-section {
  background: transparent !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .dialog-actions {
  background: #0f172a !important;
}
:host-context(body.theme-dark) h2,
:host-context(body.theme-dark) h3,
:host-context(body.theme-dark) h4,
:host-context(body.theme-dark) p,
:host-context(body.theme-dark) span,
:host-context(body.theme-dark) label,
:host-context(body.theme-dark) .user-name,
:host-context(body.theme-dark) .user-email,
:host-context(body.theme-dark) .search-icon,
:host-context(body.theme-dark) .close-ico,
:host-context(body.theme-dark) .close-ico .close-icon,
:host-context(body.theme-dark) .header-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .search-input,
:host-context(body.theme-dark) .search-input-wrapper .search-input,
:host-context(body.theme-dark) .input-container,
:host-context(body.theme-dark) .input-container input,
:host-context(body.theme-dark) input,
:host-context(body.theme-dark) textarea {
  background: #1f2937 !important;
  color: #f8fafc !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
}
:host-context(body.theme-dark) .comment-field textarea,
:host-context(body.theme-dark) .comment-field .mat-mdc-text-field-wrapper,
:host-context(body.theme-dark) .comment-field .mat-mdc-form-field-flex,
:host-context(body.theme-dark) .comment-field .mdc-text-field {
  background: transparent !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .users-list .user-option,
:host-context(body.theme-dark) .page-btn,
:host-context(body.theme-dark) .pagination-info {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .users-list .user-option,
:host-context(body.theme-dark) .users-list mat-list-option {
  --mdc-list-list-item-hover-state-layer-color: rgba(94, 161, 216, 0.12);
  --mdc-list-list-item-focus-state-layer-color: rgba(94, 161, 216, 0.16);
  --mdc-list-list-item-hover-state-layer-opacity: 1;
  --mat-list-list-item-hover-state-layer-color: rgba(94, 161, 216, 0.12);
}
:host-context(body.theme-dark) .users-list .user-option:hover,
:host-context(body.theme-dark) .users-list .user-option:focus,
:host-context(body.theme-dark) .users-list mat-list-option:hover,
:host-context(body.theme-dark) .users-list mat-list-option:focus {
  background: rgba(94, 161, 216, 0.12) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .users-list .user-option .user-name,
:host-context(body.theme-dark) .users-list .user-option .user-email,
:host-context(body.theme-dark) .users-list mat-list-option .user-name,
:host-context(body.theme-dark) .users-list mat-list-option .user-email {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .selected-user-card {
  background: #1e3a4a !important;
  border-color: rgba(94, 161, 216, 0.4) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .selected-user-card .user-name {
  color: #f0f9ff !important;
}
:host-context(body.theme-dark) .selected-user-card .user-email {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .dialog-actions .cancel-btn {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.4) !important;
}
:host-context(body.theme-dark) .dialog-actions .cancel-btn span,
:host-context(body.theme-dark) .dialog-actions .cancel-btn .mdc-button__label,
:host-context(body.theme-dark) .dialog-actions .cancel-btn mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .dialog-actions .transfer-btn,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn {
  background: #5ea1d8 !important;
  border-color: #5ea1d8 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .dialog-actions .transfer-btn span,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn span,
:host-context(body.theme-dark) .dialog-actions .transfer-btn .mdc-button__label,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn .mdc-button__label,
:host-context(body.theme-dark) .dialog-actions .transfer-btn mat-icon,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn mat-icon {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .ownership-warning,
:host-context(body.theme-dark) .ownership-warning .note-box {
  background: rgba(120, 53, 15, 0.3) !important;
  color: #fde68a !important;
  border-color: rgba(251, 191, 36, 0.45) !important;
}

:host-context(body.theme-dark) .transfer-ownership-dialog,
:host-context(body.theme-dark) .box,
:host-context(body.theme-dark) .analytics-header,
:host-context(body.theme-dark) .analytics-content,
:host-context(body.theme-dark) .dialog-content,
:host-context(body.theme-dark) .dialog-actions,
:host-context(body.theme-dark) .des-box,
:host-context(body.theme-dark) .des-box:after {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .dialog-actions {
  background: #0f172a !important;
}
:host-context(body.theme-dark) .search-input,
:host-context(body.theme-dark) .search-input-wrapper .search-input,
:host-context(body.theme-dark) .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  background: #1f2937 !important;
  color: #f8fafc !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
}
:host-context(body.theme-dark) .comment-field textarea,
:host-context(body.theme-dark) .comment-field .mat-mdc-text-field-wrapper,
:host-context(body.theme-dark) .comment-field .mat-mdc-form-field-flex,
:host-context(body.theme-dark) .comment-field .mdc-text-field {
  background: transparent !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .page-btn,
:host-context(body.theme-dark) .users-list .user-option {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .users-list .user-option,
:host-context(body.theme-dark) .users-list mat-list-option {
  --mdc-list-list-item-hover-state-layer-color: rgba(94, 161, 216, 0.12);
  --mdc-list-list-item-focus-state-layer-color: rgba(94, 161, 216, 0.16);
  --mdc-list-list-item-hover-state-layer-opacity: 1;
  --mat-list-list-item-hover-state-layer-color: rgba(94, 161, 216, 0.12);
}
:host-context(body.theme-dark) .users-list .user-option:hover,
:host-context(body.theme-dark) .users-list .user-option:focus,
:host-context(body.theme-dark) .users-list mat-list-option:hover,
:host-context(body.theme-dark) .users-list mat-list-option:focus {
  background: rgba(94, 161, 216, 0.12) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .users-list .user-option .user-name,
:host-context(body.theme-dark) .users-list .user-option .user-email,
:host-context(body.theme-dark) .users-list mat-list-option .user-name,
:host-context(body.theme-dark) .users-list mat-list-option .user-email {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .selected-user-card {
  background: #1e3a4a !important;
  border-color: rgba(94, 161, 216, 0.4) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .selected-user-card .user-name {
  color: #f0f9ff !important;
}
:host-context(body.theme-dark) .selected-user-card .user-email {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .comment-form-section {
  background: transparent !important;
  border-color: rgba(148, 163, 184, 0.2) !important;
}
:host-context(body.theme-dark) .user-name,
:host-context(body.theme-dark) .user-email,
:host-context(body.theme-dark) .section-header h3,
:host-context(body.theme-dark) .pagination-info,
:host-context(body.theme-dark) .char-count,
:host-context(body.theme-dark) .search-icon,
:host-context(body.theme-dark) .close-ico,
:host-context(body.theme-dark) .close-ico .close-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .ownership-warning,
:host-context(body.theme-dark) .ownership-warning .note-box {
  background: rgba(120, 53, 15, 0.3) !important;
  color: #fde68a !important;
  border-color: rgba(251, 191, 36, 0.45) !important;
}
:host-context(body.theme-dark) .dialog-actions .cancel-btn {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.4) !important;
}
:host-context(body.theme-dark) .dialog-actions .cancel-btn span,
:host-context(body.theme-dark) .dialog-actions .cancel-btn .mdc-button__label,
:host-context(body.theme-dark) .dialog-actions .cancel-btn mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .dialog-actions .transfer-btn,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn {
  background: #5ea1d8 !important;
  border-color: #5ea1d8 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .dialog-actions .transfer-btn span,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn span,
:host-context(body.theme-dark) .dialog-actions .transfer-btn .mdc-button__label,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn .mdc-button__label,
:host-context(body.theme-dark) .dialog-actions .transfer-btn mat-icon,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn mat-icon {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .dialog-actions .transfer-btn:disabled,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn:disabled {
  background: #374151 !important;
  border-color: #374151 !important;
  color: #6b7280 !important;
}
:host-context(body.theme-dark) .dialog-actions .transfer-btn:disabled span,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn:disabled span,
:host-context(body.theme-dark) .dialog-actions .transfer-btn:disabled .mdc-button__label,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn:disabled .mdc-button__label,
:host-context(body.theme-dark) .dialog-actions .transfer-btn:disabled mat-icon,
:host-context(body.theme-dark) .dialog-actions .confirm-user-btn:disabled mat-icon {
  color: #6b7280 !important;
}
:host-context(body.theme-dark) .avatar-placeholder {
  background: transparent !important;
  color: #94a3b8 !important;
}

@media (max-width: 480px) {
  .transfer-ownership-dialog {
    max-height: 95vh !important;
    width: 98vw !important;
    max-width: 98vw !important;
    margin: 2.5vh auto !important;
    border-radius: 6px;
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    -webkit-overflow-scrolling: touch;
  }
  .transfer-ownership-dialog .dialog-header {
    padding: 12px 0px;
    min-height: 56px;
  }
  .transfer-ownership-dialog .dialog-header h2 {
    font-size: 16px;
    line-height: 1.3;
  }
  .transfer-ownership-dialog .dialog-header .close-button {
    min-width: 44px;
    min-height: 44px;
    padding: 10px;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }
  .transfer-ownership-dialog .dialog-content {
    padding: 16px;
    max-height: calc(98vh - 120px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .transfer-ownership-dialog .dialog-content .search-section .search-input {
    min-height: 44px;
    font-size: 16px;
    padding: 10px 14px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .users-list .user-option {
    min-height: 56px;
    padding: 10px 14px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-avatar .avatar-image,
  .transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-avatar .avatar-placeholder {
    width: 44px;
    height: 44px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .users-list .user-option .user-item .user-info .user-name {
    font-size: 15px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn {
    min-width: 44px;
    min-height: 44px;
    padding: 6px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls .nav-btn mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
  }
  .transfer-ownership-dialog .dialog-content .users-section .pagination-controls .page-numbers .page-btn {
    min-width: 44px;
    min-height: 44px;
    font-size: 12px;
    padding: 6px 10px;
  }
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card {
    padding: 14px;
  }
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-avatar .avatar-image,
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-avatar .avatar-placeholder {
    width: 52px;
    height: 52px;
  }
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-info .user-name {
    font-size: 16px;
  }
  .transfer-ownership-dialog .dialog-content .selected-user-section .selected-user-card .user-info .user-email {
    font-size: 13px;
  }
  .transfer-ownership-dialog .dialog-content .ownership-warning .note-box {
    padding: 14px;
    font-size: 13px;
  }
  .transfer-ownership-dialog .dialog-content .ownership-warning .note-box .note-list {
    padding-left: 18px;
  }
  .transfer-ownership-dialog .dialog-content .ownership-warning .note-box .note-list li {
    margin-bottom: 6px;
  }
  .transfer-ownership-dialog .dialog-content .comment-form-section .form-header h4 {
    font-size: 15px;
  }
  .transfer-ownership-dialog .dialog-content .comment-form-section .form-header .char-count {
    font-size: 11px;
  }
  .transfer-ownership-dialog .dialog-content .comment-form-section .comment-field .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix textarea {
    min-height: 70px;
    font-size: 16px;
  }
  .transfer-ownership-dialog .dialog-actions {
    padding: 12px 16px;
    min-height: 56px;
    position: sticky;
    bottom: 0;
    background: #f8f9fa;
    border-top: 1px solid #e0e0e0;
    display: flex;
    gap: 8px;
    justify-content: flex-end;
  }
  .transfer-ownership-dialog .dialog-actions .cancel-btn,
  .transfer-ownership-dialog .dialog-actions .transfer-btn,
  .transfer-ownership-dialog .dialog-actions .confirm-user-btn {
    min-height: 44px;
    min-width: 100px;
    font-size: 13px;
    padding: 10px 16px;
  }
  .transfer-ownership-dialog .dialog-actions .cancel-btn mat-icon,
  .transfer-ownership-dialog .dialog-actions .transfer-btn mat-icon,
  .transfer-ownership-dialog .dialog-actions .confirm-user-btn mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
}
/* Mobile-specific dialog improvements */
@media (max-width: 768px) {
  .mat-mdc-dialog-container {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
  .mat-mdc-dialog-surface {
    padding: 0 !important;
    margin: 0 !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
  .cdk-overlay-pane {
    max-width: 100vw !important;
    max-height: 100vh !important;
  }
}
/* Additional mobile accessibility improvements */
@media (max-width: 768px) {
  *:focus {
    outline: 2px solid #5ea1d8 !important;
    outline-offset: 2px !important;
  }
  .user-option,
  .nav-btn,
  .page-btn,
  .cancel-btn,
  .transfer-btn,
  .confirm-user-btn,
  .change-user-btn {
    -webkit-tap-highlight-color: rgba(94, 161, 216, 0.2);
    transition: all 0.2s ease;
  }
  .nav-btn,
  .page-btn,
  .cancel-btn,
  .transfer-btn,
  .confirm-user-btn,
  .change-user-btn {
    -webkit-user-select: none;
    user-select: none;
  }
  .dialog-content {
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
  }
  .transfer-ownership-dialog {
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    border: 1px solid rgba(0, 0, 0, 0.08);
  }
  .searching-users {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 20px;
    color: #666;
    font-size: 14px;
  }
  .searching-users mat-spinner {
    margin-right: 8px;
  }
  .no-users {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 40px 20px;
    color: #666;
    font-size: 14px;
  }
  .no-users mat-icon {
    font-size: 48px;
    width: 48px;
    height: 48px;
    color: #ccc;
  }
  .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix input,
  .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix textarea {
    -webkit-appearance: none;
    appearance: none;
    border-radius: 0;
  }
  .user-option:hover, .user-option:focus {
    background-color: #f0f8ff;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(94, 161, 216, 0.15);
  }
  .user-option.mat-mdc-list-option-selected {
    background-color: #e3f2fd;
    border-left: 4px solid #5ea1d8;
  }
  .pagination-controls {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px 0;
    border-top: 1px solid #e0e0e0;
    margin-top: 16px;
  }
  .pagination-controls .page-numbers {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
    justify-content: center;
  }
  .progress-bar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #5ea1d8, #4a8bc2);
    border-radius: 0;
  }
}
/* Transfer Ownership Component - Clean Styles */
/* Container and Layout */
.container {
  padding: 0px !important;
  max-height: 90vh;
  overflow-y: auto;
}

.box {
  width: 100% !important;
  max-width: 800px;
  min-width: 500px;
  margin: 16px auto;
  padding: 0;
  background: #fff;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);
  overflow: hidden;
  border-radius: 22px;
}

.box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 20px 0px;
  display: flex;
  flex-wrap: wrap;
}

.des-box {
  background: #fff;
  position: relative;
  width: 100%;
}

/* Header Styles */
.analytics-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: #fff !important;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
  position: relative;
}
.analytics-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}
.analytics-header .header-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #333;
  background: transparent !important;
  border: none !important;
  box-shadow: none;
}

.close-ico {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #666;
  opacity: 1 !important;
  z-index: 10;
  cursor: pointer;
  background: transparent;
  border: none;
}

.close-ico .close-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}

/* Content Styles */
.analytics-content {
  flex: 1;
  overflow-y: auto;
  background: #fff !important;
}

.dialog-content {
  padding: 24px;
}

/* Search Section */
.search-section {
  margin-bottom: 24px;
}
.search-section .search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.search-section .search-input-wrapper .search-icon {
  position: absolute;
  left: 12px;
  color: #666;
  z-index: 1;
}
.search-section .search-input-wrapper .search-input {
  width: 100%;
  padding: 12px 12px 12px 44px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s ease;
}
.search-section .search-input-wrapper .search-input:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);
}
.search-section .search-input-wrapper .search-input::placeholder {
  color: #999;
}

/* Users Section */
.users-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.users-section .section-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.users-section .section-header .pagination-info {
  font-size: 12px;
  color: #666;
  background: #f5f5f5;
  padding: 4px 8px;
  border-radius: 12px;
}
.users-section .searching-users {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: #666;
}
.users-section .no-users {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  color: #999;
}
.users-section .users-list {
  margin-bottom: 16px;
}
.users-section .users-list .user-option {
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background-color 0.2s ease;
}
.users-section .users-list .user-option:hover {
  background-color: #f8f9fa;
}
.users-section .users-list .user-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  min-width: 0;
}
.users-section .users-list .user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.users-section .users-list .avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.users-section .users-list .avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
}
.users-section .users-list .user-info {
  flex: 1;
  min-width: 0;
}
.users-section .users-list .user-name {
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
  font-size: 14px;
}
.users-section .users-list .user-email {
  color: #666;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.users-section .pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
}
.users-section .nav-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.users-section .nav-btn:hover {
  background: #f5f5f5;
}
.users-section .nav-btn:disabled:hover {
  background: transparent;
}
.users-section .page-numbers {
  display: flex;
  gap: 4px;
}
.users-section .page-btn {
  min-width: 32px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #e0e0e0;
  background: #fff;
  color: #666;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.users-section .page-btn:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #ccc;
}
.users-section .page-btn.active {
  background: #5ea1d8;
  color: #fff;
  border-color: #5ea1d8;
}

/* Selected User Section */
.selected-user-section .selected-user-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.selected-user-section .selected-user-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.selected-user-section .selected-user-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
.selected-user-section .selected-user-card .user-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.selected-user-section .selected-user-card .avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.selected-user-section .selected-user-card .avatar-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f5f5f5 0%, #f5f5f5 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}
.selected-user-section .selected-user-card .user-info {
  flex: 1;
}
.selected-user-section .selected-user-card .user-info .user-name {
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  font-size: 16px;
}
.selected-user-section .selected-user-card .user-info .user-email {
  color: #666;
  font-size: 14px;
}

/* Ownership Warning */
.ownership-warning {
  margin-bottom: 20px;
}
.ownership-warning .note-box {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  color: #856404;
}
.ownership-warning .note-box .note-list {
  margin: 12px 0 0 0;
  padding-left: 20px;
}
.ownership-warning .note-box .note-list li {
  margin-bottom: 8px;
}

/* Comment Form Section */
.comment-form-section {
  margin-bottom: 20px;
}
.comment-form-section .form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.comment-form-section .form-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}
.comment-form-section .form-header .char-count {
  font-size: 12px;
  color: #666;
}
.comment-form-section .comment-field {
  width: 100%;
}

/* Dialog Actions */
.dialog-actions {
  padding: 16px 20px;
  min-height: 60px;
  position: sticky;
  bottom: 0;
  background: #f8f9fa;
  border-top: 1px solid #e0e0e0;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: flex-end;
}
.dialog-actions .cancel-btn,
.dialog-actions .transfer-btn,
.dialog-actions .confirm-user-btn {
  min-height: 48px;
  min-width: 120px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  padding: 12px 20px;
}
.dialog-actions .cancel-btn mat-icon,
.dialog-actions .transfer-btn mat-icon,
.dialog-actions .confirm-user-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  margin-right: 8px;
}
.dialog-actions .cancel-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
}
.dialog-actions .cancel-btn:hover {
  background: #e8e8e8;
}
.dialog-actions .transfer-btn,
.dialog-actions .confirm-user-btn {
  background: #5ea1d8;
  color: white;
}
.dialog-actions .transfer-btn:hover:not(:disabled),
.dialog-actions .confirm-user-btn:hover:not(:disabled) {
  background: #4a8bc2;
}
.dialog-actions .transfer-btn:disabled,
.dialog-actions .confirm-user-btn:disabled {
  background: #ccc;
  color: #999;
}

/* Progress Bar */
.progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .box {
    max-width: 100% !important;
    min-width: auto;
    margin: 8px;
    padding: 0;
    border-radius: 16px;
  }
  .close-ico {
    top: 16px !important;
    right: 20px;
  }
  .dialog-content {
    padding: 16px;
  }
  .dialog-actions {
    padding: 12px 16px;
    min-height: 56px;
    gap: 8px;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  .dialog-actions .cancel-btn,
  .dialog-actions .transfer-btn,
  .dialog-actions .confirm-user-btn {
    min-height: 44px;
    min-width: 100px;
    font-size: 13px;
    padding: 10px 16px;
  }
  .dialog-actions .cancel-btn mat-icon,
  .dialog-actions .transfer-btn mat-icon,
  .dialog-actions .confirm-user-btn mat-icon {
    font-size: 16px;
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/transfer-ownership/transfer-ownership.component.scss"],"names":[],"mappings":"AAAA,4BAAA;AACA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AACF;AACE;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAGA,kBAAA;AACA;EACE,kBAAA;EACA,mBAAA;AAAF;AAEE;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AAGE;EACE,WAAA;EACA,eAAA;EACA,SAAA;AADJ;;AAKA,mBAAA;AACA;EACE,mBAAA;AAFF;AAIE;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;AAFJ;AAII;EACE,qBAAA;AAFN;AAKI;EACE,WAAA;AAHN;;AAQA,kBAAA;AACA;EACE,mBAAA;AALF;AAOE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,iCAAA;AALJ;AAOI;EACE,yBAAA;AALN;AAQI;EACE,kBAAA;AANN;AASI;EACE,kBAAA;EACA,eAAA;AAPN;AASM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAPR;AAUM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AARR;AAUQ;EACE,eAAA;EACA,WAAA;AARV;AAaI;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAXN;AAaM;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AAXR;AAcM;EACE,WAAA;EACA,eAAA;AAZR;AAeM;EACE,WAAA;EACA,eAAA;AAbR;;AAmBA,oBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AAhBF;AAkBE;EACE,iBAAA;AAhBJ;;AAoBA,mBAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,0BAAA;AAjBF;AAmBE;EACE,WAAA;AAjBJ;AAoBE;EACE,yBAAA;EACA,YAAA;AAlBJ;AAoBI;EACE,sBAAA;EACA,WAAA;AAlBN;;AAuBA,UAAA;AAEA;EACE,uBAAA;AArBF;;AAuBA;EACE,iBAAA;AApBF;;AAsBA;EACE,yBAAA;AAnBF;;AAsBA;EACE,kCAAA;EACA,aAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;AAnBF;;AAsBA,cAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AApBF;;AAuBA;EAEE,kCAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EAEA,4CAAA;EACA,kBAAA;EACA,6BAAA;AApBF;;AAuBA;EACE,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,kBAAA;EAEA,4BAAA;AApBF;;AAuBA,SAAA;AAEA;EACE,cAAA;AArBF;;AAwBA;EACE,cAAA;EACA,gCAAA;AArBF;;AAwBA,mBAAA;AAEA;;;EAGE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;EAEA,iDAAA;EAEA,8BAAA;EACA,0BAAA;EAKA,gCAAA;AAtBF;;AAyBA;;;EAGE,yBAAA;AAtBF;;AAyBA;;;EAOE,sBAAA;AAtBF;;AAyBA;;EAEE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EAKA,gCAAA;EAEA,8BAAA;AAtBF;;AAyBA;;EAEE,sBAAA;EACA,gCAAA;AAtBF;;AAyBA;;EAEE,cAAA;AAtBF;;AAyBA,eAAA;AAEA,uCAAA;AACA;EAEE,0BAAA;EAEA,sBAAA;EAEA,yBAAA;AAvBF;AAuCA;EACE;IACE,UAAA;IAEA,mCAAA;EAxBF;EA0BA;IACE,UAAA;IAEA,eAAA;EAxBF;AACF;AA2BA,kCAAA;AAiBA;EACE;IACE,UAAA;EAzBF;EA2BA;IACE,UAAA;EAzBF;AACF;AA4BA;EACE,UAAA;EAGA,2BAAA;EAIA,6BAAA;EAIA,sBAAA;AA5BF;;AA+BA;EAGE,qBAAA;AA5BF;;AA+BA;EAGE,qBAAA;EACA,6BAAA;AA5BF;;AA+BA;EAGE,qBAAA;EACA,6BAAA;AA5BF;;AA+BA;EAGE,mBAAA;EACA,6BAAA;AA5BF;;AA+BA,kCAAA;AACA;EACE,cAAA;EACA,OAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AA5BF;;AA+BA;EACE,cAAA;AA5BF;;AA+BA;EACE,WAAA;AA5BF;;AA+BA,WAAA;AAEA;EACE,aAAA;AA7BF;;AAgCA;EACE,UAAA;AA7BF;;AA+BA;EACE,mBAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;AA5BF;;AA+BA;EACE,WAAA;AA5BF;;AA+BA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AA5BF;;AA+BA;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;AA5BF;;AA8BA;EACE,gBAAA;EACA,sBAAA;EAGA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,oBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8EAAA;EACA,gBAAA;EACA,6HAAA;EACA,sBAAA;EACA,2BAAA;EACA,gCAAA;EACA,gBAAA;EACA,uCAAA;EACA,mCAAA;EACA,yBAAA;EACA,+BAAA;EACA,qBAAA;EACA,wCAAA;UAAA,gCAAA;AA7BF;;AA+BA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AA5BF;;AA8BA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AA3BF;;AA8BA;EACE,gBAAA;EACA,uBAAA;AA3BF;AA4BE;EACE,sBAAA;AA1BJ;;AA8BA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AA3BF;AAkCM;EACE,8BAAA;EACA,2BAAA;AAhCR;AAoCE;EACE,yBAAA;AAlCJ;;AAqCA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAnCF;;AAqCA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EAEA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAnCF;;AAsCA;EACE,yBAAA;EACA,WAAA;AAnCF;;AAqCA;EACE,qBAAA;EACA,uBAAA;AAlCF;;AAoCA;EACE,6BAAA;AAjCF;;AAmCA;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAhCF;;AAkCA;EACE,WAAA;EACA,YAAA;AA/BF;;AAiCA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AA9BF;;AAgCA;EACE,iBAAA;AA7BF;;AAgCA;EACE,0BAAA;EACA,aAAA;EACA,8BAAA;AA7BF;;AA+BA;EACE,gBAAA;EACA,kBAAA;AA5BF;;AA+BA;;EAEE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA5BF;;AA8BA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AA3BF;;AA6BA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;AA1BF;;AA4BA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAzBF;;AA4BA;EACE,aAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EAGA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AA3BF;;AA8BA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EAEA,uCAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,kDAAA;AA5BF;;AA+BA;EACE,yBAAA;EACA,6CAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AA5BF;;AAgCA;EACE,UAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AA7BF;;AAgCA;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;AA7BF;;AA+BA;EACE,aAAA;EACA,mBAAA;AA5BF;AA6BE;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,6BAAA;AA3BJ;;AA8BA;EACE,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AA3BF;;AA6BA;EACE,8BAAA;EACA,iBAAA;EACA,gBAAA;AA1BF;AA2BE;EACE,aAAA;AAzBJ;;AA4BA;EACE;IACE,eAAA;EAzBF;EA2BA;IACE,iBAAA;EAzBF;EA2BA;IACE,YAAA;EAzBF;AACF;AA2BA,uFAAA;AACA;;EAEE,qBAAA;EACA,+BAAA;EACA,uBAAA;AAzBF;;AA2BA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AAxBF;;AA0BA;EACE,gBAAA;EACA,0BAAA;EACA,kBAAA;AAvBF;;AAyBA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AAtBF;;AAyBA;EACE,gBAAA;EACA,uBAAA;AAtBF;AAuBE;EACE,sBAAA;AArBJ;;AAyBA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAtBF;AA6BM;EACE,8BAAA;EACA,2BAAA;EACA,2BAAA;AA3BR;AA+BE;EACE,yBAAA;AA7BJ;;AAgCA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AA7BF;;AAgCA;EACE,yBAAA;EACA,aAAA;AA7BF;;AA+BA;EACE,6BAAA;AA5BF;;AA8BA;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AA3BF;;AA6BA;EACE,WAAA;EACA,YAAA;AA1BF;;AA4BA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAzBF;;AA2BA;EACE,iBAAA;AAxBF;;AA2BA;EACE,0BAAA;EACA,aAAA;EACA,8BAAA;AAxBF;;AA0BA;EACE,gBAAA;EACA,kBAAA;AAvBF;;AA0BA;;EAEE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAvBF;;AAyBA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAtBF;;AAwBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;AArBF;;AAuBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApBF;;AAuBA;EACE,aAAA;EACA,kBAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EAGA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AAtBF;;AAyBA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,uCAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,kDAAA;AAtBF;;AAyBA;EACE,yBAAA;EACA,6CAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AAtBF;;AA0BA;EACE,UAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AAvBF;;AA0BA;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;AAvBF;;AAyBA;EACE,aAAA;EACA,mBAAA;AAtBF;AAuBE;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,6BAAA;AArBJ;;AAwBA;EACE,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AArBF;;AAuBA;EACE,8BAAA;EACA,iBAAA;EACA,gBAAA;AApBF;AAqBE;EACE,aAAA;AAnBJ;;AAsBA;EACE;IACE,eAAA;IACA,2BAAA;EAnBF;EAoBE;IACE,WAAA;IACA,cAAA;EAlBJ;EAqBA;IACE,0BAAA;IACA,sBAAA;IACA,6BAAA;IACA,4BAAA;IACA,6BAAA;IACA,oBAAA;IACA,qBAAA;IACA,0BAAA;IACA,2BAAA;EAnBF;AACF;AAqBA;EACE,YAAA;EACA,gBAAA;AAnBF;AAoBE;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;AAlBJ;AAqBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAnBJ;AAoBI;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;AAlBN;AAoBM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAlBR;AAuBE;EACE,gBAAA;AArBJ;AAuBI;EACE,iBAAA;AArBN;;AA0BA,yBAAA;AACA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAvBF;AAyBE;EACE,SAAA;AAvBJ;AAyBI;EACE,WAAA;AAvBN;AA0BI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAxBN;AA2BI;EACE,WAAA;EAWA,4EAAA;AAnCN;AA0BM;EACE,WAAA;AAxBR;AA2BM;EACE,sBAAA;EACA,kBAAA;AAzBR;AA8BM;EACE,eAAA;EACA,cAAA;AA5BR;AA8BQ;EACE,cAAA;EACA,YAAA;AA5BV;AAgCM;EACE,cAAA;EACA,eAAA;AA9BR;;AAoCA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;AAjCF;AAoCE;EACE,mBAAA;EACA,cAAA;AAlCJ;AAsCE;EAlBF;IAmBI,yBAAA;EAnCF;AACF;AAsCE;EACE;IACE,qCAAA;IACA,uCAAA;IACA,sCAAA;EApCJ;AACF;AAuCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EAEA,WAAA;EACA,gCAAA;AAtCJ;AAwCI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAtCN;AAyCI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAvCN;AA0CI;EACE,kCAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;EACA,2BAAA;AAxCN;AA0CM;EACE,WAAA;EACA,kCAAA;AAxCR;AA2CM;EACE,kCAAA;EACA,2BAAA;AAzCR;AA8CE;EACE,cAAA;EACA,gBAAA;EACA,aAAA;AA5CJ;AA8CI;EACE,mBAAA;AA5CN;AA8CM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AA5CR;AA8CQ;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AA5CV;AA+CQ;EACE,WAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AA7CV;AA+CU;EACE,aAAA;EAEA,6CAAA;AA9CZ;AAiDU;EACE,WAAA;AA/CZ;AAsDM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AApDR;AAsDQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AApDV;AAuDQ;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AArDV;AAyDM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AAvDR;AAyDQ;EACE,eAAA;AAvDV;AA2DM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AAzDR;AA2DQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAzDV;AA4DQ;EACE,eAAA;AA1DV;AA8DM;EACE,mBAAA;AA5DR;AA8DQ;EACE,kBAAA;EACA,kBAAA;EACA,sCAAA;AA5DV;AA8DU;EACE,yBAAA;AA5DZ;AA+DU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AA7DZ;AA+DY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA7Dd;AA+Dc;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA7DhB;AAgEc;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AA9DhB;AAgEgB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA9DlB;AAmEY;EACE,OAAA;EACA,YAAA;AAjEd;AAmEc;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAjEhB;AAoEc;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAlEhB;AAyEM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AAvER;AAyEQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvEV;AAyEU;EACE,YAAA;AAvEZ;AA0EU;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;AAxEZ;AA4EQ;EACE,aAAA;EACA,QAAA;AA1EV;AA4EU;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;AA1EZ;AA4EY;EACE,mBAAA;EACA,kBAAA;AA1Ed;AA6EY;EACE,mBAAA;EACA,YAAA;EACA,qBAAA;AA3Ed;AA8EY;EACE,YAAA;EACA,mBAAA;AA5Ed;AAmFI;EACE,mBAAA;AAjFN;AAmFM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAjFR;AAmFQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAjFV;AAoFQ;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAlFV;AAoFU;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAlFZ;AAuFM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AArFR;AAuFQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AArFV;AAuFU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AArFZ;AAwFU;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAtFZ;AAwFY;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAtFd;AA2FQ;EACE,OAAA;AAzFV;AA2FU;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAzFZ;AA4FU;EACE,WAAA;EACA,eAAA;AA1FZ;AAgGI;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AA9FN;AAgGM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AA9FR;AAgGQ;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AA9FV;AAiGQ;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA/FV;AAmGM;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAjGR;AAsGM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AApGR;AAsGQ;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AApGV;AAuGQ;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AArGV;AAyGM;EACE,WAAA;AAvGR;AAyGQ;EACE,iBAAA;AAvGV;AA0GQ;EACE,kBAAA;AAxGV;AA2GQ;EACE,eAAA;EACA,gBAAA;AAzGV;AA+GE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AA7GJ;AA+GI;;;EAGE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;AA7GN;AA+GM;;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3GR;AA+GI;EACE,iBAAA;EACA,WAAA;EACA,yBAAA;AA7GN;AA8GM;EACE,mBAAA;EACA,kBAAA;AA5GR;AAgHI;EACE,mBAAA;EACA,YAAA;EACA,YAAA;AA9GN;AAgHM;EACE,mBAAA;EACA,2BAAA;EACA,6CAAA;AA9GR;AAiHM;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA/GR;AAmHI;EACE,mBAAA;EACA,YAAA;EACA,YAAA;AAjHN;AAmHM;EACE,mBAAA;EACA,2BAAA;EACA,8CAAA;AAjHR;AAoHM;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAlHR;AAuHE;EACE,WAAA;EACA,gBAAA;AArHJ;;AA0HA;EACE;IACE,2BAAA;IACA,sBAAA;IACA,0BAAA;IACA,6BAAA;IACA,kBAAA;IACA,6BAAA;IACA,oBAAA;IACA,qBAAA;IACA,0BAAA;IACA,iCAAA;EAvHF;EAyHE;IACE,kBAAA;IACA,gBAAA;EAvHJ;EAyHI;IACE,eAAA;IACA,gBAAA;EAvHN;EA0HI;IACE,eAAA;IACA,gBAAA;IACA,YAAA;IACA,kCAAA;IACA,uBAAA;IACA,2BAAA;EAxHN;EA4HE;IACE,aAAA;IACA,8BAAA;IACA,gBAAA;IACA,iCAAA;EA1HJ;EA4HI;IACE,mBAAA;EA1HN;EA4HM;IACE,gBAAA;IACA,eAAA;IACA,kBAAA;EA1HR;EA+HM;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;IACA,mBAAA;EA7HR;EA+HQ;IACE,oBAAA;IACA,eAAA;EA7HV;EAkIQ;IACE,gBAAA;IACA,kBAAA;EAhIV;EAoIc;;IAEE,WAAA;IACA,YAAA;EAlIhB;EAuIc;IACE,eAAA;IACA,gBAAA;EArIhB;EA4IM;IACE,gBAAA;IACA,QAAA;EA1IR;EA4IQ;IACE,eAAA;IACA,gBAAA;IACA,YAAA;EA1IV;EA4IU;IACE,eAAA;IACA,WAAA;IACA,YAAA;EA1IZ;EA8IQ;IACE,QAAA;EA5IV;EA8IU;IACE,eAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;EA5IZ;EAkJI;IACE,mBAAA;EAhJN;EAkJM;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;IACA,mBAAA;EAhJR;EAkJQ;IACE,oBAAA;IACA,gBAAA;IACA,iBAAA;EAhJV;EAoJM;IACE,aAAA;IACA,kBAAA;IACA,mBAAA;EAlJR;EAqJU;;IAEE,WAAA;IACA,YAAA;EAnJZ;EAwJU;IACE,eAAA;IACA,gBAAA;EAtJZ;EAyJU;IACE,eAAA;IACA,WAAA;EAvJZ;EA6JI;IACE,mBAAA;EA3JN;EA6JM;IACE,aAAA;IACA,kBAAA;IACA,eAAA;IACA,gBAAA;EA3JR;EA6JQ;IACE,cAAA;IACA,kBAAA;EA3JV;EA6JU;IACE,kBAAA;EA3JZ;EAkKM;IACE,mBAAA;EAhKR;EAkKQ;IACE,eAAA;IACA,kBAAA;EAhKV;EAmKQ;IACE,eAAA;EAjKV;EA0KgB;IACE,gBAAA;IACA,eAAA;IACA,gBAAA;EAxKlB;EAkLE;IACE,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,SAAA;IACA,mBAAA;IACA,6BAAA;IACA,aAAA;IACA,SAAA;IACA,yBAAA;EAhLJ;EAkLI;;;IAGE,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,kBAAA;EAhLN;EAkLM;;;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;EA9KR;EAkLI;IACE,mBAAA;IACA,WAAA;IACA,sBAAA;EAhLN;EAkLM;IACE,mBAAA;EAhLR;EAoLI;;IAEE,mBAAA;IACA,YAAA;EAlLN;EAoLM;;IACE,mBAAA;EAjLR;EAoLM;;IACE,gBAAA;IACA,WAAA;EAjLR;AACF;AAuLA,iEAAA;AAEE;;;;;;;;EAQE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAtLJ;AAyLE;EACE,kCAAA;EACA,iDAAA;AAvLJ;AA0LE;EACE,8BAAA;AAxLJ;AA2LE;;;;;;;;;;;;;;;EAeE,yBAAA;AAzLJ;AA4LE;;;;;;EAME,8BAAA;EACA,yBAAA;EACA,kDAAA;AA1LJ;AA6LE;;;;EAIE,kCAAA;EACA,iDAAA;AA3LJ;AA8LE;;EAEE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA5LJ;AA+LE;;EAEE,sEAAA;EACA,sEAAA;EACA,iDAAA;EACA,sEAAA;AA7LJ;AAgME;;;;EAIE,+CAAA;EACA,yBAAA;AA9LJ;AAiME;;;;EAIE,yBAAA;AA/LJ;AAkME;EACE,8BAAA;EACA,gDAAA;EACA,yBAAA;AAhMJ;AAmME;EACE,yBAAA;AAjMJ;AAoME;EACE,yBAAA;AAlMJ;AAqME;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAnMJ;AAsME;;;EAGE,yBAAA;AApMJ;AAuME;;EAEE,8BAAA;EACA,gCAAA;EACA,yBAAA;AArMJ;AAwME;;;;;;EAME,yBAAA;AAtMJ;AAyME;;EAEE,8BAAA;EACA,gCAAA;EACA,yBAAA;AAvMJ;AA0ME;;;;;;EAME,yBAAA;AAxMJ;AA2ME;;EAEE,6CAAA;EACA,yBAAA;EACA,iDAAA;AAzMJ;;AA6MA,iDAAA;AAEE;;;;;;;;EAQE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA3MJ;AA8ME;EACE,kCAAA;EACA,iDAAA;AA5MJ;AA+ME;EACE,8BAAA;AA7MJ;AAgNE;;;;;;;;;;;;EAYE,yBAAA;AA9MJ;AAiNE;;;;;;EAME,8BAAA;EACA,yBAAA;EACA,kDAAA;AA/MJ;AAkNE;;;;EAIE,kCAAA;EACA,iDAAA;AAhNJ;AAmNE;;;EAGE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAjNJ;AAoNE;;EAEE,sEAAA;EACA,sEAAA;EACA,iDAAA;EACA,sEAAA;AAlNJ;AAqNE;;;;EAIE,+CAAA;EACA,yBAAA;AAnNJ;AAsNE;;;;EAIE,yBAAA;AApNJ;AAuNE;EACE,8BAAA;EACA,gDAAA;EACA,yBAAA;AArNJ;AAwNE;EACE,yBAAA;AAtNJ;AAyNE;EACE,yBAAA;AAvNJ;AA0NE;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAxNJ;AA2NE;;;EAGE,yBAAA;AAzNJ;AA4NE;;EAEE,8BAAA;EACA,gCAAA;EACA,yBAAA;AA1NJ;AA6NE;;;;;;EAME,yBAAA;AA3NJ;AA8NE;;EAEE,6CAAA;EACA,yBAAA;EACA,iDAAA;AA5NJ;;AAiOE;;;;;;;;EAQE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA9NJ;AAiOE;EACE,8BAAA;AA/NJ;AAkOE;;;EAGE,8BAAA;EACA,yBAAA;EACA,kDAAA;AAhOJ;AAmOE;;;;EAIE,kCAAA;EACA,iDAAA;AAjOJ;AAoOE;;EAEE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAlOJ;AAsOE;;EAEE,sEAAA;EACA,sEAAA;EACA,iDAAA;EACA,sEAAA;AApOJ;AAuOE;;;;EAIE,+CAAA;EACA,yBAAA;AArOJ;AAwOE;;;;EAIE,yBAAA;AAtOJ;AAyOE;EACE,8BAAA;EACA,gDAAA;EACA,yBAAA;AAvOJ;AA0OE;EACE,yBAAA;AAxOJ;AA2OE;EACE,yBAAA;AAzOJ;AA4OE;EACE,kCAAA;EACA,iDAAA;AA1OJ;AA6OE;;;;;;;;EAQE,yBAAA;AA3OJ;AA8OE;;EAEE,6CAAA;EACA,yBAAA;EACA,iDAAA;AA5OJ;AA+OE;EACE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA7OJ;AAgPE;;;EAGE,yBAAA;AA9OJ;AAiPE;;EAEE,8BAAA;EACA,gCAAA;EACA,yBAAA;AA/OJ;AAkPE;;;;;;EAME,yBAAA;AAhPJ;AAmPE;;EAEE,8BAAA;EACA,gCAAA;EACA,yBAAA;AAjPJ;AAoPE;;;;;;EAME,yBAAA;AAlPJ;AAqPE;EACE,kCAAA;EACA,yBAAA;AAnPJ;;AAuPA;EACE;IACE,2BAAA;IACA,sBAAA;IACA,0BAAA;IACA,6BAAA;IACA,kBAAA;IACA,6BAAA;IACA,oBAAA;IACA,qBAAA;IACA,0BAAA;IACA,iCAAA;EApPF;EAsPE;IACE,iBAAA;IACA,gBAAA;EApPJ;EAsPI;IACE,eAAA;IACA,gBAAA;EApPN;EAuPI;IACE,eAAA;IACA,gBAAA;IACA,aAAA;IACA,kCAAA;IACA,uBAAA;IACA,2BAAA;EArPN;EAyPE;IACE,aAAA;IACA,8BAAA;IACA,gBAAA;IACA,iCAAA;EAvPJ;EA0PM;IACE,gBAAA;IACA,eAAA;IACA,kBAAA;EAxPR;EA8PQ;IACE,gBAAA;IACA,kBAAA;EA5PV;EAgQc;;IAEE,WAAA;IACA,YAAA;EA9PhB;EAmQc;IACE,eAAA;EAjQhB;EAyQQ;IACE,eAAA;IACA,gBAAA;IACA,YAAA;EAvQV;EAyQU;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAvQZ;EA4QU;IACE,eAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;EA1QZ;EAiRM;IACE,aAAA;EA/QR;EAkRU;;IAEE,WAAA;IACA,YAAA;EAhRZ;EAqRU;IACE,eAAA;EAnRZ;EAsRU;IACE,eAAA;EApRZ;EA2RM;IACE,aAAA;IACA,eAAA;EAzRR;EA2RQ;IACE,kBAAA;EAzRV;EA2RU;IACE,kBAAA;EAzRZ;EAiSQ;IACE,eAAA;EA/RV;EAkSQ;IACE,eAAA;EAhSV;EAySgB;IACE,gBAAA;IACA,eAAA;EAvSlB;EAiTE;IACE,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,SAAA;IACA,mBAAA;IACA,6BAAA;IACA,aAAA;IACA,QAAA;IACA,yBAAA;EA/SJ;EAiTI;;;IAGE,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;EA/SN;EAiTM;;;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;EA7SR;AACF;AAmTA,wCAAA;AACA;EACE;IACE,qBAAA;IACA,oBAAA;IACA,2BAAA;IACA,4BAAA;EAjTF;EAoTA;IACE,qBAAA;IACA,oBAAA;IACA,2BAAA;IACA,4BAAA;EAlTF;EAqTA;IACE,2BAAA;IACA,4BAAA;EAnTF;AACF;AAsTA,iDAAA;AACA;EAEE;IACE,qCAAA;IACA,8BAAA;EArTF;EAyTA;;;;;;;IAOE,oDAAA;IACA,yBAAA;EAvTF;EA2TA;;;;;;IAME,yBAAA;IAGA,iBAAA;EAzTF;EA6TA;IACE,uBAAA;IACA,iCAAA;EA3TF;EA+TA;IACE,0CAAA;IACA,qCAAA;EA7TF;EAiUA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,SAAA;IACA,aAAA;IACA,WAAA;IACA,eAAA;EA/TF;EAiUE;IACE,iBAAA;EA/TJ;EAmUA;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,SAAA;IACA,kBAAA;IACA,WAAA;IACA,eAAA;EAjUF;EAmUE;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;EAjUJ;EA0UQ;;IAEE,wBAAA;IACA,gBAAA;IACA,gBAAA;EAxUV;EAiVE;IAEE,yBAAA;IACA,2BAAA;IACA,8CAAA;EAhVJ;EAmVE;IACE,yBAAA;IACA,8BAAA;EAjVJ;EAsVA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;IACA,QAAA;IACA,eAAA;IACA,6BAAA;IACA,gBAAA;EApVF;EAsVE;IACE,aAAA;IACA,QAAA;IACA,eAAA;IACA,uBAAA;EApVJ;EAyVA;IACE,kBAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;IACA,oDAAA;IACA,gBAAA;EAvVF;AACF;AA0VA,gDAAA;AAEA,yBAAA;AACA;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;AAzVF;;AA4VA;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,4CAAA;EACA,gBAAA;EACA,mBAAA;AAzVF;;AA4VA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AAzVF;;AA4VA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;AAzVF;;AA4VA,kBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,gCAAA;EACA,kBAAA;AAzVF;AA2VE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAzVJ;AA4VE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kCAAA;EACA,uBAAA;EACA,gBAAA;AA1VJ;;AA8VA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;AA3VF;;AA8VA;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA3VF;;AA8VA,mBAAA;AACA;EACE,OAAA;EACA,gBAAA;EACA,2BAAA;AA3VF;;AA8VA;EACE,aAAA;AA3VF;;AA8VA,mBAAA;AACA;EACE,mBAAA;AA3VF;AA6VE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AA3VJ;AA6VI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AA3VN;AA8VI;EACE,WAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;AA5VN;AA8VM;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA5VR;AA+VM;EACE,WAAA;AA7VR;;AAmWA,kBAAA;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAjWJ;AAmWI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAjWN;AAoWI;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAlWN;AAsWE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AApWJ;AAuWE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;AArWJ;AAwWE;EACE,mBAAA;AAtWJ;AAwWI;EACE,kBAAA;EACA,kBAAA;EACA,sCAAA;AAtWN;AAwWM;EACE,yBAAA;AAtWR;AA0WI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;AAxWN;AA2WI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAzWN;AA4WI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA1WN;AA6WI;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AA3WN;AA8WI;EACE,OAAA;EACA,YAAA;AA5WN;AA+WI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AA7WN;AAgXI;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA9WN;AAkXE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;AAhXJ;AAmXE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjXJ;AAmXI;EACE,mBAAA;AAjXN;AAoXI;EACE,uBAAA;AAlXN;AAsXE;EACE,aAAA;EACA,QAAA;AApXJ;AAuXE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AArXJ;AAuXI;EACE,mBAAA;EACA,kBAAA;AArXN;AAwXI;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;AAtXN;;AA2XA,0BAAA;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAzXJ;AA2XI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAzXN;AA6XE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AA3XJ;AA6XI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA3XN;AA8XI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA5XN;AA+XI;EACE,WAAA;EACA,YAAA;EACA,6DAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AA7XN;AAgYI;EACE,OAAA;AA9XN;AAgYM;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AA9XR;AAiYM;EACE,WAAA;EACA,eAAA;AA/XR;;AAqYA,sBAAA;AACA;EACE,mBAAA;AAlYF;AAoYE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AAlYJ;AAoYI;EACE,kBAAA;EACA,kBAAA;AAlYN;AAoYM;EACE,kBAAA;AAlYR;;AAwYA,yBAAA;AACA;EACE,mBAAA;AArYF;AAuYE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AArYJ;AAuYI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AArYN;AAwYI;EACE,eAAA;EACA,WAAA;AAtYN;AA0YE;EACE,WAAA;AAxYJ;;AA4YA,mBAAA;AACA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,qBAAA;AAzYF;AA2YE;;;EAGE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAzYJ;AA2YI;;;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAvYN;AA2YE;EACE,mBAAA;EACA,WAAA;EACA,sBAAA;AAzYJ;AA2YI;EACE,mBAAA;AAzYN;AA6YE;;EAEE,mBAAA;EACA,YAAA;AA3YJ;AA6YI;;EACE,mBAAA;AA1YN;AA6YI;;EACE,gBAAA;EACA,WAAA;AA1YN;;AA+YA,iBAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AA5YF;;AA+YA,sBAAA;AACA;EACE;IACE,0BAAA;IACA,eAAA;IACA,WAAA;IACA,UAAA;IACA,mBAAA;EA5YF;EA+YA;IACE,oBAAA;IACA,WAAA;EA7YF;EAgZA;IACE,aAAA;EA9YF;EAiZA;IACE,kBAAA;IACA,gBAAA;IACA,QAAA;IACA,aAAA;IACA,uBAAA;IACA,qBAAA;EA/YF;EAiZE;;;IAGE,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;EA/YJ;EAiZI;;;IACE,eAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;EA7YN;AACF","sourcesContent":["/* Create Flow Mode Notice */\n.create-flow-notice {\n  background: #e3f2fd;\n  border: 1px solid #5ea1d8;\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #1976d2;\n\n  .notice-icon {\n    color: #5ea1d8;\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n/* Title Section */\n.title-section {\n  text-align: center;\n  margin-bottom: 20px;\n\n  h2 {\n    color: #333;\n    margin-bottom: 8px;\n    font-size: 24px;\n    font-weight: 600;\n  }\n\n  p {\n    color: #666;\n    font-size: 14px;\n    margin: 0;\n  }\n}\n\n/* Search Section */\n.search-section {\n  margin-bottom: 20px;\n\n  .search-input {\n    width: 100%;\n    padding: 12px 16px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.3s;\n\n    &:focus {\n      border-color: #5ea1d8;\n    }\n\n    &::placeholder {\n      color: #999;\n    }\n  }\n}\n\n/* Users Section */\n.users-section {\n  margin-bottom: 20px;\n\n  .user-item {\n    display: flex;\n    align-items: center;\n    padding: 12px;\n    border-bottom: 1px solid #eee;\n    transition: background-color 0.2s;\n\n    &:hover {\n      background-color: #f8f9fa;\n    }\n\n    .transfer-checkbox {\n      margin-right: 16px;\n    }\n\n    .user-avatar {\n      margin-right: 16px;\n      cursor: pointer;\n\n      .avatar-image {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        object-fit: cover;\n      }\n\n      .avatar-placeholder {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        background-color: #e0e0e0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        .material-icons {\n          font-size: 24px;\n          color: #666;\n        }\n      }\n    }\n\n    .user-info {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      .user-name {\n        font-weight: 600;\n        color: #333;\n        font-size: 16px;\n      }\n\n      .user-username {\n        color: #666;\n        font-size: 14px;\n      }\n\n      .user-email {\n        color: #999;\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n/* Loading Section */\n.loading-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 20px;\n  color: #666;\n\n  mat-spinner {\n    margin-right: 8px;\n  }\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n\n  .cancel-btn {\n    color: #666;\n  }\n\n  .confirm-btn {\n    background-color: #5ea1d8;\n    color: white;\n\n    &:disabled {\n      background-color: #ccc;\n      color: #666;\n    }\n  }\n}\n\n/* BASIC */\n\n.Login {\n  background-color: white;\n}\n.banner {\n  margin-top: 200px;\n}\nhtml {\n  background-color: #56baed;\n}\n\nbody {\n  font-family: \"Poppins\", sans-serif;\n  height: 100vh;\n}\n\na {\n  color: #92badd;\n  display: inline-block;\n  text-decoration: none;\n  font-weight: 400;\n}\n\nh2 {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  display: inline-block;\n  margin: 40px 8px 10px 8px;\n  color: #cccccc;\n}\n\n/* STRUCTURE */\n\n.wrapper {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  width: 100%;\n  min-height: 100%;\n  padding: 20px;\n}\n\n#formContent {\n  -webkit-border-radius: 10px 10px 10px 10px;\n  border-radius: 10px 10px 10px 10px;\n  background: #fff;\n  padding: 30px;\n  width: 90%;\n  max-width: 450px;\n  position: relative;\n  padding: 0px;\n  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);\n  text-align: center;\n  border: 0.5px solid lightgrey;\n}\n\n#formFooter {\n  background-color: #f6f6f6;\n  border-top: 1px solid #dce8f1;\n  padding: 25px;\n  text-align: center;\n  -webkit-border-radius: 0 0 10px 10px;\n  border-radius: 0 0 10px 10px;\n}\n\n/* TABS */\n\nh2.inactive {\n  color: #cccccc;\n}\n\nh2.active {\n  color: #0d0d0d;\n  border-bottom: 2px solid #5fbae9;\n}\n\n/* FORM TYPOGRAPHY*/\n\ninput[type=\"button\"],\ninput[type=\"submit\"],\ninput[type=\"reset\"] {\n  background-color: #56baed;\n  border: none;\n  color: white;\n  padding: 15px 80px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  text-transform: uppercase;\n  font-size: 13px;\n  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n  margin: 5px 20px 40px 20px;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\ninput[type=\"button\"]:hover,\ninput[type=\"submit\"]:hover,\ninput[type=\"reset\"]:hover {\n  background-color: #39ace7;\n}\n\ninput[type=\"button\"]:active,\ninput[type=\"submit\"]:active,\ninput[type=\"reset\"]:active {\n  -moz-transform: scale(0.95);\n  -webkit-transform: scale(0.95);\n  -o-transform: scale(0.95);\n  -ms-transform: scale(0.95);\n  transform: scale(0.95);\n}\n\ninput[type=\"text\"],\ninput[type=\"password\"] {\n  background-color: #f6f6f6;\n  border: none;\n  color: #0d0d0d;\n  padding: 15px 32px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 16px;\n  margin: 5px;\n  width: 85%;\n  border: 2px solid #f6f6f6;\n  -webkit-transition: all 0.5s ease-in-out;\n  -moz-transition: all 0.5s ease-in-out;\n  -ms-transition: all 0.5s ease-in-out;\n  -o-transition: all 0.5s ease-in-out;\n  transition: all 0.5s ease-in-out;\n  -webkit-border-radius: 5px 5px 5px 5px;\n  border-radius: 5px 5px 5px 5px;\n}\n\ninput[type=\"text\"]:focus,\ninput[type=\"password\"]:focus {\n  background-color: #fff;\n  border-bottom: 2px solid #5fbae9;\n}\n\ninput[type=\"text\"]:placeholder,\ninput[type=\"password\"] {\n  color: #cccccc;\n}\n\n/* ANIMATIONS */\n\n/* Simple CSS3 Fade-in-down Animation */\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n/* Simple CSS3 Fade-in Animation */\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@-moz-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.fadeIn {\n  opacity: 0;\n  -webkit-animation: fadeIn ease-in 1;\n  -moz-animation: fadeIn ease-in 1;\n  animation: fadeIn ease-in 1;\n\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-fill-mode: forwards;\n  animation-fill-mode: forwards;\n\n  -webkit-animation-duration: 1s;\n  -moz-animation-duration: 1s;\n  animation-duration: 1s;\n}\n\n.fadeIn.first {\n  -webkit-animation-delay: 0.4s;\n  -moz-animation-delay: 0.4s;\n  animation-delay: 0.4s;\n}\n\n.fadeIn.second {\n  -webkit-animation-delay: 0.6s;\n  -moz-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.third {\n  -webkit-animation-delay: 0.8s;\n  -moz-animation-delay: 0.8s;\n  animation-delay: 0.8s;\n  border: 0.5px solid lightgrey;\n}\n\n.fadeIn.fourth {\n  -webkit-animation-delay: 1s;\n  -moz-animation-delay: 1s;\n  animation-delay: 1s;\n  border: 0.5px solid lightgrey;\n}\n\n/* Simple CSS3 Fade-in Animation */\n.underlineHover:after {\n  display: block;\n  left: 0;\n  bottom: -10px;\n  width: 0;\n  height: 2px;\n  background-color: #56baed;\n  content: \"\";\n  transition: width 0.2s;\n}\n\n.underlineHover:hover {\n  color: #0d0d0d;\n}\n\n.underlineHover:hover:after {\n  width: 100%;\n}\n\n/* OTHERS */\n\n*:focus {\n  outline: none;\n}\n\n#icon {\n  width: 60%;\n}\n.mat-badge-content {\n  background: #5ea1d8;\n}\n\n.example-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.example-full-width {\n  width: 100%;\n}\n\n.img-div-left {\n  position: fixed;\n  z-index: 999;\n  height: 150px;\n  width: 150px;\n  overflow: visible;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.container {\n  padding: 0px !important;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n.box {\n  max-width: 560px;\n  width: 100% !important;\n  // max-height:90vh;\n  // min-height:77vh !important;\n  margin: 10px;\n  padding: 0px 25px;\n  background: #fff !important;\n  background-size: 50%;\n  background-position: top center;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);\n  overflow: hidden;\n  background: \"https://flowchest-cdn.azureedge.net/mediaimage/Screenshot 2023-05-05 1448027cea2b039f4a4049a42ef2bcf6c81c54.png\";\n  background-size: cover;\n  background-position: center;\n  border-radius: 15px 15px 0px 0px;\n  margin: 0px auto;\n  background-repeat: no-repeat !important;\n  background-size: contain !important;\n  background-size: 100% 90%;\n  background-position: top center;\n  opacity: 1 !important;\n  backdrop-filter: none !important;\n}\n.box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.box:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 1;\n  // background: rgba(0, 0, 0, 0.5);\n}\n.with-icon {\n  text-align: left;\n  height: 35px !important;\n  img {\n    margin: 0px !important;\n  }\n}\n\n.des-box {\n  background: #fff;\n  position: relative;\n  width: 100%;\n  background: #fff;\n  position: relative;\n  // height: 300px;\n  // overflow-y: scroll;\n  // overflow-x: hidden;\n  // word-break: break-all;\n  & > div {\n    & > div {\n      mat-card {\n        background: #f3f1f1 !important;\n        background: #fff !important;\n      }\n    }\n  }\n  i {\n    color: #212427 !important;\n  }\n}\n.des-box:after {\n  content: \"\";\n  width: 200%;\n  height: 100vh;\n  // height:-webkit-fill-available;\n  background: #fff;\n  border-radius: 0px;\n  position: absolute;\n  top: 0px;\n  z-index: -1;\n  left: -50%;\n  right: -50%;\n}\n.des-box:before {\n  content: \"\";\n  width: 200%;\n  height: 40vh;\n  // height:-webkit-fill-available;\n  background: #fff;\n  border-radius: 100% 100% 0px 0px;\n  position: absolute;\n  top: -34px;\n  z-index: -1;\n  left: -50%;\n  right: -50%;\n}\n\n.title-box {\n  padding: 0px 0px 60px 0px;\n  width: 100%;\n}\n.priceIcon-p {\n  top: unset !important;\n  bottom: 20px !important;\n}\n.title-div {\n  border-bottom: 1px solid gray;\n}\n.title-box h2 {\n  color: #fff !important;\n  font-size: 18px;\n  font-weight: normal;\n  margin-bottom: 20px;\n  text-align: left;\n}\n.title-box ul {\n  margin: 0px;\n  padding: 0px;\n}\n.title-box ul li {\n  color: #fff;\n  list-style: none;\n  padding: 8px 10px 8px 0px;\n  font-size: 16px;\n  text-align: left;\n}\n.title-box ul li span {\n  margin-right: 8px;\n}\n\n.footer-div {\n  border-top: 1px solid gray;\n  display: flex;\n  justify-content: space-between;\n}\n.footer-div p {\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\np,\nh5 {\n  color: #212427 !important;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\nh5 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 0px;\n  margin-bottom: 10px;\n}\n.close-ico {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  color: #212427;\n  opacity: 1 !important;\n  z-index: 10;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n}\n.close-ico .close-icon {\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n}\n\n.code-div {\n  height: 200px;\n  overflow-y: scroll;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  height: 2.8rem;\n  width: 100%;\n  // min-width: 200px;\n  // max-width: 250px;\n  background-color: #fff;\n  border-radius: 8px;\n  margin-top: 10px;\n  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);\n}\n\n.input-container input {\n  height: 100%;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid rgb(176 190 197);\n  // background-color: transparent;\n  padding: 0.625rem 70px 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n  color: rgb(69 90 100);\n  outline: none;\n  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.input-container input:focus {\n  border: 1px solid #5ea1d8;\n  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.2);\n}\n\n.invite-btn {\n  position: absolute;\n  cursor: pointer;\n  right: 4px;\n  top: 4px;\n  bottom: 4px;\n  z-index: 10;\n  border-radius: 4px;\n  background-color: #5ea1d8;\n  color: white;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  border: none;\n  // transition: .6s ease;\n}\n\n.invite-btn:hover {\n  right: 2px;\n  top: 2px;\n  bottom: 2px;\n  border-radius: 8px;\n}\n\n.input-container input:placeholder-shown ~ .invite-btn {\n  pointer-events: none;\n  background-color: #5ea1d8;\n  opacity: 0.5;\n}\nform {\n  display: flex;\n  align-items: center;\n  input {\n    background-color: #f6f6f6;\n    border: none;\n    color: #0d0d0d;\n    padding: 15px 32px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 5px;\n    width: 85%;\n    border: 2px solid #f6f6f6;\n    transition: all 0.5s ease-in-out;\n    border-radius: 5px;\n    outline: none !important;\n    border: 0.5px solid lightgrey;\n  }\n}\n.parent-comment-box {\n  background: #f3f1f1 !important;\n  padding: 10px;\n  max-height: 400px;\n  overflow-y: scroll;\n}\n.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {\n  background: #f8f8f8 !important;\n  margin-left: 40px;\n  margin-top: 10px;\n  mat-card {\n    padding: 10px;\n  }\n}\n@media (max-width: 767px) {\n  p {\n    flex-wrap: wrap;\n  }\n  .box {\n    max-height: 100vh;\n  }\n  .des-box:after {\n    height: 45vh;\n  }\n}\n/* Ensure the dialog surface remains fully vivid and clickable like the comment popup */\n::ng-deep .cdk-overlay-pane.dialoguebox .mat-mdc-dialog-container,\n::ng-deep .cdk-overlay-pane.dialoguebox .mat-mdc-dialog-surface {\n  opacity: 1 !important;\n  pointer-events: auto !important;\n  filter: none !important;\n}\n.box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.popuptitle {\n  text-align: left;\n  font-size: 20px !important;\n  padding-left: 15px;\n}\n.box:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 1;\n  // background: rgba(0, 0, 0, 0.5);\n}\n.with-icon {\n  text-align: left;\n  height: 35px !important;\n  img {\n    margin: 0px !important;\n  }\n}\n\n.des-box {\n  background: #fff;\n  position: relative;\n  width: 100%;\n  background: #fff;\n  position: relative;\n  // height: 300px;\n  // overflow-y: scroll;\n  // overflow-x: hidden;\n  // word-break: break-all;\n  & > div {\n    & > div {\n      mat-card {\n        background: #f3f1f1 !important;\n        background: #fff !important;\n        box-shadow: none !important;\n      }\n    }\n  }\n  i {\n    color: #212427 !important;\n  }\n}\n.des-box:after {\n  content: \"\";\n  width: 200%;\n  height: 100vh;\n  background: #fff;\n  border-radius: 0px !important;\n  position: absolute;\n  top: -100px;\n  z-index: -1;\n  left: -50%;\n  right: -50%;\n}\n\n.title-box {\n  padding: 0px 0px 80px 0px;\n  display: none;\n}\n.title-div {\n  border-bottom: 1px solid gray;\n}\n.title-box h2 {\n  color: #fff !important;\n  font-size: 18px;\n  font-weight: normal;\n  margin-bottom: 20px;\n  text-align: left;\n}\n.title-box ul {\n  margin: 0px;\n  padding: 0px;\n}\n.title-box ul li {\n  color: #fff;\n  list-style: none;\n  padding: 8px 10px 8px 0px;\n  font-size: 16px;\n  text-align: left;\n}\n.title-box ul li span {\n  margin-right: 8px;\n}\n\n.footer-div {\n  border-top: 1px solid gray;\n  display: flex;\n  justify-content: space-between;\n}\n.footer-div p {\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\np,\nh5 {\n  color: #212427 !important;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\nh5 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 0px;\n  margin-bottom: 10px;\n}\n.close-ico {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  color: #212427;\n  opacity: 1 !important;\n  z-index: 10;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n}\n.close-ico .close-icon {\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n}\n\n.code-div {\n  height: 200px;\n  overflow-y: scroll;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  height: 2.8rem;\n  width: 100%;\n  // min-width: 200px;\n  // max-width: 250px;\n  background-color: #fff;\n  border-radius: 8px;\n  margin-top: 10px;\n  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);\n}\n\n.input-container input {\n  height: 100%;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid rgb(176 190 197);\n  background-color: transparent;\n  padding: 0.625rem 70px 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n  color: rgb(69 90 100);\n  outline: none;\n  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.input-container input:focus {\n  border: 1px solid #5ea1d8;\n  box-shadow: 0 0 0 2px rgba(94, 161, 216, 0.2);\n}\n\n.invite-btn {\n  position: absolute;\n  cursor: pointer;\n  right: 4px;\n  top: 4px;\n  bottom: 4px;\n  z-index: 10;\n  border-radius: 4px;\n  background-color: #5ea1d8;\n  color: white;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  border: none;\n  // transition: .6s ease;\n}\n\n.invite-btn:hover {\n  right: 2px;\n  top: 2px;\n  bottom: 2px;\n  border-radius: 8px;\n}\n\n.input-container input:placeholder-shown ~ .invite-btn {\n  pointer-events: none;\n  background-color: #5ea1d8;\n  opacity: 0.5;\n}\nform {\n  display: flex;\n  align-items: center;\n  input {\n    background-color: #f6f6f6;\n    border: none;\n    color: #0d0d0d;\n    padding: 15px 32px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 5px;\n    width: 85%;\n    border: 2px solid #f6f6f6;\n    transition: all 0.5s ease-in-out;\n    border-radius: 5px;\n    outline: none !important;\n    border: 0.5px solid lightgrey;\n  }\n}\n.parent-comment-box {\n  background: #f3f1f1 !important;\n  padding: 10px;\n  max-height: 400px;\n  overflow-y: scroll;\n}\n.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {\n  background: #f8f8f8 !important;\n  margin-left: 40px;\n  margin-top: 10px;\n  mat-card {\n    padding: 10px;\n  }\n}\n@media (max-width: 767px) {\n  p {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    span {\n      width: 100%;\n      display: block;\n    }\n  }\n  .box {\n    max-width: 95vw !important;\n    width: 95vw !important;\n    margin: 2.5vh auto !important;\n    padding: 0px 15px !important;\n    position: relative !important;\n    top: auto !important;\n    left: auto !important;\n    transform: none !important;\n    max-height: 90vh !important;\n  }\n}\n.ownership-warning {\n  margin: 20px;\n  text-align: left;\n  .note-box {\n    background-color: #fff3cd;\n    color: #856404;\n    border: 1px solid #ffeeba;\n    border-radius: 5px;\n    padding: 15px;\n    font-size: 14px;\n  }\n\n  .note-list {\n    margin: 10px 0;\n    padding-left: 0;\n    list-style: none;\n    li {\n      position: relative;\n      padding-left: 20px;\n      margin-bottom: 8px;\n\n      &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        top: 6px;\n        width: 8px;\n        height: 8px;\n        background-color: #856404;\n        border-radius: 50%;\n      }\n    }\n  }\n\n  .ownership-buttons {\n    margin-top: 15px;\n\n    button + button {\n      margin-left: 10px;\n    }\n  }\n}\n\n/* Comment Form Styling */\n.comment-form-section {\n  margin: 20px;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n\n  .example-form {\n    margin: 0;\n\n    .w-100 {\n      width: 100%;\n    }\n\n    .font16 {\n      font-size: 16px;\n      font-weight: 500;\n      color: #495057;\n    }\n\n    mat-form-field {\n      width: 100%;\n\n      .mat-mdc-form-field {\n        width: 100%;\n      }\n\n      .mat-mdc-text-field-wrapper {\n        background-color: #fff;\n        border-radius: 6px;\n      }\n\n      /* removed empty .mat-mdc-form-field-focus-overlay block to satisfy linter */\n\n      input {\n        font-size: 14px;\n        color: #495057;\n\n        &::placeholder {\n          color: #6c757d;\n          opacity: 0.7;\n        }\n      }\n\n      .mat-mdc-form-field-hint {\n        color: #6c757d;\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n.transfer-ownership-dialog {\n  display: flex;\n  flex-direction: column;\n  max-height: 80vh;\n  width: 100%;\n  max-width: 600px;\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n\n  // Dark mode support\n  :host-context(body.theme-dark) & {\n    background: #1a1a1a;\n    color: #ffffff;\n  }\n\n  // High contrast support\n  @media (prefers-contrast: high) {\n    border: 2px solid #000000;\n  }\n\n  // Reduced motion support\n  @media (prefers-reduced-motion: reduce) {\n    * {\n      animation-duration: 0.01ms !important;\n      animation-iteration-count: 1 !important;\n      transition-duration: 0.01ms !important;\n    }\n  }\n\n  .dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 24px;\n    // background: transparent;\n    color: #333;\n    border-bottom: 1px solid #e0e0e0;\n\n    h2 {\n      margin: 0;\n      font-size: 20px;\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      gap: 2px;\n      color: #333;\n    }\n\n    .header-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n      color: #333;\n    }\n\n    .close-button {\n      background: transparent !important;\n      border: none !important;\n      box-shadow: none !important;\n      color: #666;\n      transition: color 0.2s ease;\n\n      &:hover {\n        color: #333;\n        background: transparent !important;\n      }\n\n      &:focus {\n        background: transparent !important;\n        box-shadow: none !important;\n      }\n    }\n  }\n\n  .dialog-content {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    padding: 24px;\n\n    .search-section {\n      margin-bottom: 24px;\n\n      .search-input-wrapper {\n        position: relative;\n        display: flex;\n        align-items: center;\n\n        .search-icon {\n          position: absolute;\n          left: 12px;\n          color: #666;\n          z-index: 1;\n        }\n\n        .search-input {\n          width: 100%;\n          padding: 12px 12px 12px 44px;\n          border: 2px solid #e0e0e0;\n          border-radius: 8px;\n          font-size: 14px;\n          transition: border-color 0.2s ease;\n\n          &:focus {\n            outline: none;\n            // border-color: #5ea1d8;\n            box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);\n          }\n\n          &::placeholder {\n            color: #999;\n          }\n        }\n      }\n    }\n\n    .users-section {\n      .section-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 16px;\n\n        h3 {\n          margin: 0;\n          font-size: 16px;\n          font-weight: 600;\n          color: #333;\n        }\n\n        .pagination-info {\n          font-size: 12px;\n          color: #666;\n          background: #f5f5f5;\n          padding: 4px 8px;\n          border-radius: 12px;\n        }\n      }\n\n      .searching-users {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 12px;\n        padding: 32px;\n        color: #666;\n\n        span {\n          font-size: 14px;\n        }\n      }\n\n      .no-users {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 12px;\n        padding: 32px;\n        color: #999;\n\n        mat-icon {\n          font-size: 48px;\n          width: 48px;\n          height: 48px;\n          opacity: 0.5;\n        }\n\n        span {\n          font-size: 14px;\n        }\n      }\n\n      .users-list {\n        margin-bottom: 16px;\n\n        .user-option {\n          border-radius: 8px;\n          margin-bottom: 8px;\n          transition: background-color 0.2s ease;\n\n          &:hover {\n            background-color: #f8f9fa;\n          }\n\n          .user-item {\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            padding: 8px 0;\n\n            .user-avatar {\n              width: 40px;\n              height: 40px;\n              border-radius: 50%;\n              overflow: hidden;\n              flex-shrink: 0;\n\n              .avatar-image {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n              }\n\n              .avatar-placeholder {\n                width: 100%;\n                height: 100%;\n                background: linear-gradient(135deg, #f5f5f5 0%, #f5f5f5 100%);\n                color: white;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                font-size: 16px;\n                font-weight: 600;\n\n                mat-icon {\n                  font-size: 20px;\n                  width: 20px;\n                  height: 20px;\n                  color: white;\n                }\n              }\n            }\n\n            .user-info {\n              flex: 1;\n              min-width: 0;\n\n              .user-name {\n                font-weight: 600;\n                color: #333;\n                margin-bottom: 2px;\n                font-size: 14px;\n              }\n\n              .user-email {\n                color: #666;\n                font-size: 12px;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n              }\n            }\n          }\n        }\n      }\n\n      .pagination-controls {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        margin-top: 16px;\n\n        .nav-btn {\n          width: 32px;\n          height: 32px;\n          border-radius: 50%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n\n          &:disabled {\n            opacity: 0.5;\n          }\n\n          mat-icon {\n            font-size: 18px;\n            width: 18px;\n            height: 18px;\n            line-height: 1;\n            overflow: visible;\n          }\n        }\n\n        .page-numbers {\n          display: flex;\n          gap: 4px;\n\n          .page-btn {\n            min-width: 32px;\n            height: 32px;\n            border-radius: 6px;\n            font-size: 12px;\n            font-weight: 500;\n            border: 1px solid #e0e0e0;\n            background: white;\n            color: #666;\n            transition: all 0.2s ease;\n\n            &:hover:not(:disabled) {\n              background: #f5f5f5;\n              border-color: #ccc;\n            }\n\n            &.active {\n              background: #5ea1d8;\n              color: white;\n              border-color: #5ea1d8;\n            }\n\n            &:disabled {\n              opacity: 0.5;\n              cursor: not-allowed;\n            }\n          }\n        }\n      }\n    }\n\n    .selected-user-section {\n      margin-bottom: 24px;\n\n      .selected-user-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 16px;\n\n        h3 {\n          margin: 0;\n          font-size: 16px;\n          font-weight: 600;\n          color: #333;\n        }\n\n        .change-user-btn {\n          color: #5ea1d8;\n          font-size: 12px;\n          padding: 4px 8px;\n          min-height: 32px;\n\n          mat-icon {\n            font-size: 16px;\n            width: 16px;\n            height: 16px;\n          }\n        }\n      }\n\n      .selected-user-card {\n        display: flex;\n        align-items: center;\n        gap: 16px;\n        padding: 16px;\n        background: #f8f9fa;\n        border-radius: 8px;\n        border: 2px solid #e9ecef;\n\n        .user-avatar {\n          width: 48px;\n          height: 48px;\n          border-radius: 50%;\n          overflow: hidden;\n          flex-shrink: 0;\n\n          .avatar-image {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n          }\n\n          .avatar-placeholder {\n            width: 100%;\n            height: 100%;\n            background: linear-gradient(135deg, #f5f5f5 0%, #f5f5f5 100%);\n            color: white;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 20px;\n            font-weight: 600;\n\n            mat-icon {\n              font-size: 24px;\n              width: 24px;\n              height: 24px;\n              color: white;\n            }\n          }\n        }\n\n        .user-info {\n          flex: 1;\n\n          .user-name {\n            font-weight: 600;\n            color: #333;\n            margin-bottom: 4px;\n            font-size: 16px;\n          }\n\n          .user-email {\n            color: #666;\n            font-size: 14px;\n          }\n        }\n      }\n    }\n\n    .ownership-warning {\n      background: #fff3cd;\n      border: 1px solid #ffeaa7;\n      border-radius: 8px;\n      padding: 16px;\n      margin-bottom: 24px;\n\n      .warning-header {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        margin-bottom: 8px;\n\n        .warning-icon {\n          color: #f39c12;\n          font-size: 20px;\n          width: 20px;\n          height: 20px;\n        }\n\n        h4 {\n          margin: 0;\n          color: #856404;\n          font-size: 14px;\n          font-weight: 600;\n        }\n      }\n\n      p {\n        margin: 0;\n        color: #856404;\n        font-size: 13px;\n        line-height: 1.4;\n      }\n    }\n\n    .comment-form-section {\n      .form-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 12px;\n\n        h4 {\n          margin: 0;\n          font-size: 14px;\n          font-weight: 600;\n          color: #333;\n        }\n\n        .char-count {\n          font-size: 12px;\n          color: #666;\n          background: #f5f5f5;\n          padding: 2px 6px;\n          border-radius: 8px;\n        }\n      }\n\n      .comment-field {\n        width: 100%;\n\n        ::ng-deep .mat-form-field-wrapper {\n          padding-bottom: 0;\n        }\n\n        ::ng-deep .mat-form-field-outline {\n          border-radius: 8px;\n        }\n\n        textarea {\n          font-size: 14px;\n          line-height: 1.4;\n        }\n      }\n    }\n  }\n\n  .dialog-actions {\n    display: flex;\n    gap: 12px;\n    padding: 20px 24px;\n    background: #f8f9fa;\n    border-top: 1px solid #e9ecef;\n    position: sticky;\n    bottom: 0;\n    align-items: center;\n    justify-content: flex-end;\n    flex-wrap: nowrap;\n    overflow-x: visible;\n    overflow-y: hidden;\n\n    .cancel-btn,\n    .transfer-btn,\n    .confirm-user-btn {\n      height: 40px;\n      border-radius: 8px;\n      font-weight: 500;\n      font-size: 14px;\n      transition: all 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 8px;\n      min-width: 100px;\n      flex: 0 1 auto;\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n\n    .cancel-btn {\n      background: white;\n      color: #666;\n      border: 1px solid #e0e0e0;\n      &:hover {\n        background: #f5f5f5;\n        border-color: #ccc;\n      }\n    }\n\n    .confirm-user-btn {\n      background: #28a745;\n      color: white;\n      border: none;\n\n      &:hover:not(:disabled) {\n        background: #218838;\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n      }\n\n      &:disabled {\n        background: #ccc;\n        cursor: not-allowed;\n        transform: none;\n        box-shadow: none;\n      }\n    }\n\n    .transfer-btn {\n      background: #5ea1d8;\n      color: white;\n      border: none;\n\n      &:hover:not(:disabled) {\n        background: #56baed;\n        transform: translateY(-1px);\n        box-shadow: 0 4px 12px rgba(94, 161, 216, 0.3);\n      }\n\n      &:disabled {\n        background: #ccc;\n        cursor: not-allowed;\n        transform: none;\n        box-shadow: none;\n      }\n    }\n  }\n\n  .progress-bar {\n    height: 4px;\n    border-radius: 0;\n  }\n}\n\n// Mobile Responsiveness\n@media (max-width: 768px) {\n  .transfer-ownership-dialog {\n    max-height: 95vh !important;\n    width: 95vw !important;\n    max-width: 50vh !important;\n    margin: 2.5vh auto !important;\n    border-radius: 8px;\n    position: relative !important;\n    top: auto !important;\n    left: auto !important;\n    transform: none !important;\n    -webkit-overflow-scrolling: touch; // Smooth scrolling on iOS\n\n    .dialog-header {\n      padding: 16px 20px;\n      min-height: 60px; // Ensure adequate touch target\n\n      h2 {\n        font-size: 18px;\n        line-height: 1.3;\n      }\n\n      .close-button {\n        min-width: 44px; // WCAG touch target minimum\n        min-height: 44px;\n        padding: 8px;\n        background: transparent !important;\n        border: none !important;\n        box-shadow: none !important;\n      }\n    }\n\n    .dialog-content {\n      padding: 20px;\n      max-height: calc(95vh - 140px);\n      overflow-y: auto;\n      -webkit-overflow-scrolling: touch; // Smooth scrolling on iOS\n\n      .search-section {\n        margin-bottom: 20px;\n\n        .search-input {\n          min-height: 44px; // WCAG touch target minimum\n          font-size: 16px; // Prevent zoom on iOS\n          padding: 12px 16px;\n        }\n      }\n\n      .users-section {\n        .section-header {\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 8px;\n          margin-bottom: 16px;\n\n          .pagination-info {\n            align-self: flex-end;\n            font-size: 14px;\n          }\n        }\n\n        .users-list {\n          .user-option {\n            min-height: 60px; // Larger touch targets\n            padding: 12px 16px;\n\n            .user-item {\n              .user-avatar {\n                .avatar-image,\n                .avatar-placeholder {\n                  width: 48px; // Slightly larger for better visibility\n                  height: 48px;\n                }\n              }\n\n              .user-info {\n                .user-name {\n                  font-size: 16px;\n                  line-height: 1.4;\n                }\n              }\n            }\n          }\n        }\n\n        .pagination-controls {\n          margin-top: 16px;\n          gap: 8px;\n\n          .nav-btn {\n            min-width: 44px; // WCAG touch target minimum\n            min-height: 44px;\n            padding: 8px;\n\n            mat-icon {\n              font-size: 18px;\n              width: 18px;\n              height: 18px;\n            }\n          }\n\n          .page-numbers {\n            gap: 4px;\n\n            .page-btn {\n              min-width: 44px; // WCAG touch target minimum\n              min-height: 44px;\n              font-size: 14px;\n              padding: 8px 12px;\n            }\n          }\n        }\n      }\n\n      .selected-user-section {\n        margin-bottom: 20px;\n\n        .selected-user-header {\n          flex-direction: column;\n          align-items: flex-start;\n          gap: 12px;\n          margin-bottom: 16px;\n\n          .change-user-btn {\n            align-self: flex-end;\n            min-height: 44px; // WCAG touch target minimum\n            padding: 8px 16px;\n          }\n        }\n\n        .selected-user-card {\n          padding: 16px;\n          border-radius: 8px;\n          background: #f8f9fa;\n\n          .user-avatar {\n            .avatar-image,\n            .avatar-placeholder {\n              width: 56px; // Larger for selected user\n              height: 56px;\n            }\n          }\n\n          .user-info {\n            .user-name {\n              font-size: 18px;\n              font-weight: 600;\n            }\n\n            .user-email {\n              font-size: 14px;\n              color: #666;\n            }\n          }\n        }\n      }\n\n      .ownership-warning {\n        margin-bottom: 20px;\n\n        .note-box {\n          padding: 16px;\n          border-radius: 8px;\n          font-size: 14px;\n          line-height: 1.5;\n\n          .note-list {\n            margin: 12px 0;\n            padding-left: 20px;\n\n            li {\n              margin-bottom: 8px;\n            }\n          }\n        }\n      }\n\n      .comment-form-section {\n        .form-header {\n          margin-bottom: 12px;\n\n          h4 {\n            font-size: 16px;\n            margin-bottom: 8px;\n          }\n\n          .char-count {\n            font-size: 12px;\n          }\n        }\n\n        .comment-field {\n          .mat-mdc-form-field {\n            .mat-mdc-text-field-wrapper {\n              .mat-mdc-form-field-flex {\n                .mat-mdc-form-field-infix {\n                  textarea {\n                    min-height: 80px;\n                    font-size: 16px; // Prevent zoom on iOS\n                    line-height: 1.4;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .dialog-actions {\n      padding: 16px 20px;\n      min-height: 60px; // Increased for better touch targets\n      position: sticky;\n      bottom: 0;\n      background: #f8f9fa;\n      border-top: 1px solid #e0e0e0;\n      display: flex;\n      gap: 12px;\n      justify-content: flex-end;\n\n      .cancel-btn,\n      .transfer-btn,\n      .confirm-user-btn {\n        min-height: 48px; // WCAG touch target minimum\n        min-width: 120px;\n        font-size: 14px;\n        font-weight: 500;\n        border-radius: 6px;\n        padding: 12px 20px;\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n          margin-right: 8px;\n        }\n      }\n\n      .cancel-btn {\n        background: #f5f5f5;\n        color: #666;\n        border: 1px solid #ddd;\n\n        &:hover {\n          background: #e8e8e8;\n        }\n      }\n\n      .transfer-btn,\n      .confirm-user-btn {\n        background: #5ea1d8;\n        color: white;\n\n        &:hover:not(:disabled) {\n          background: #4a8bc2;\n        }\n\n        &:disabled {\n          background: #ccc;\n          color: #999;\n        }\n      }\n    }\n  }\n}\n\n/* Final dark-mode override for transfer dialog text + surfaces */\n:host-context(body.theme-dark) {\n  .box,\n  .analytics-header,\n  .analytics-content,\n  .box-wrap,\n  .des-box,\n  .dialog-content,\n  .dialog-actions,\n  .selected-user-card {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .comment-form-section {\n    background: transparent !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .dialog-actions {\n    background: #0f172a !important;\n  }\n\n  h2,\n  h3,\n  h4,\n  p,\n  span,\n  label,\n  small,\n  .user-name,\n  .user-email,\n  .search-icon,\n  .close-ico,\n  .close-ico .close-icon,\n  .header-icon,\n  .pagination-info,\n  .char-count {\n    color: #e2e8f0 !important;\n  }\n\n  .search-input,\n  .search-input-wrapper .search-input,\n  .input-container,\n  .input-container input,\n  input,\n  textarea {\n    background: #1f2937 !important;\n    color: #f8fafc !important;\n    border-color: rgba(148, 163, 184, 0.45) !important;\n  }\n\n  .comment-field textarea,\n  .comment-field .mat-mdc-text-field-wrapper,\n  .comment-field .mat-mdc-form-field-flex,\n  .comment-field .mdc-text-field {\n    background: transparent !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .users-list .user-option,\n  .page-btn {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .users-list .user-option,\n  .users-list mat-list-option {\n    --mdc-list-list-item-hover-state-layer-color: rgba(94, 161, 216, 0.12);\n    --mdc-list-list-item-focus-state-layer-color: rgba(94, 161, 216, 0.16);\n    --mdc-list-list-item-hover-state-layer-opacity: 1;\n    --mat-list-list-item-hover-state-layer-color: rgba(94, 161, 216, 0.12);\n  }\n\n  .users-list .user-option:hover,\n  .users-list .user-option:focus,\n  .users-list mat-list-option:hover,\n  .users-list mat-list-option:focus {\n    background: rgba(94, 161, 216, 0.12) !important;\n    color: #e2e8f0 !important;\n  }\n\n  .users-list .user-option .user-name,\n  .users-list .user-option .user-email,\n  .users-list mat-list-option .user-name,\n  .users-list mat-list-option .user-email {\n    color: #e2e8f0 !important;\n  }\n\n  .selected-user-card {\n    background: #1e3a4a !important;\n    border-color: rgba(94, 161, 216, 0.4) !important;\n    color: #e2e8f0 !important;\n  }\n\n  .selected-user-card .user-name {\n    color: #f0f9ff !important;\n  }\n\n  .selected-user-card .user-email {\n    color: #94a3b8 !important;\n  }\n\n  .dialog-actions .cancel-btn {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.4) !important;\n  }\n\n  .dialog-actions .cancel-btn span,\n  .dialog-actions .cancel-btn .mdc-button__label,\n  .dialog-actions .cancel-btn mat-icon {\n    color: #e2e8f0 !important;\n  }\n\n  .dialog-actions .transfer-btn,\n  .dialog-actions .confirm-user-btn {\n    background: #5ea1d8 !important;\n    border-color: #5ea1d8 !important;\n    color: #ffffff !important;\n  }\n\n  .dialog-actions .transfer-btn span,\n  .dialog-actions .confirm-user-btn span,\n  .dialog-actions .transfer-btn .mdc-button__label,\n  .dialog-actions .confirm-user-btn .mdc-button__label,\n  .dialog-actions .transfer-btn mat-icon,\n  .dialog-actions .confirm-user-btn mat-icon {\n    color: #ffffff !important;\n  }\n\n  .dialog-actions .transfer-btn:disabled,\n  .dialog-actions .confirm-user-btn:disabled {\n    background: #374151 !important;\n    border-color: #374151 !important;\n    color: #6b7280 !important;\n  }\n\n  .dialog-actions .transfer-btn:disabled span,\n  .dialog-actions .confirm-user-btn:disabled span,\n  .dialog-actions .transfer-btn:disabled .mdc-button__label,\n  .dialog-actions .confirm-user-btn:disabled .mdc-button__label,\n  .dialog-actions .transfer-btn:disabled mat-icon,\n  .dialog-actions .confirm-user-btn:disabled mat-icon {\n    color: #6b7280 !important;\n  }\n\n  .ownership-warning,\n  .ownership-warning .note-box {\n    background: rgba(120, 53, 15, 0.3) !important;\n    color: #fde68a !important;\n    border-color: rgba(251, 191, 36, 0.45) !important;\n  }\n}\n\n/* Final dark override (must stay at file end). */\n:host-context(body.theme-dark) {\n  .box,\n  .analytics-header,\n  .analytics-content,\n  .box-wrap,\n  .des-box,\n  .dialog-content,\n  .dialog-actions,\n  .selected-user-card {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .comment-form-section {\n    background: transparent !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .dialog-actions {\n    background: #0f172a !important;\n  }\n\n  h2,\n  h3,\n  h4,\n  p,\n  span,\n  label,\n  .user-name,\n  .user-email,\n  .search-icon,\n  .close-ico,\n  .close-ico .close-icon,\n  .header-icon {\n    color: #e2e8f0 !important;\n  }\n\n  .search-input,\n  .search-input-wrapper .search-input,\n  .input-container,\n  .input-container input,\n  input,\n  textarea {\n    background: #1f2937 !important;\n    color: #f8fafc !important;\n    border-color: rgba(148, 163, 184, 0.45) !important;\n  }\n\n  .comment-field textarea,\n  .comment-field .mat-mdc-text-field-wrapper,\n  .comment-field .mat-mdc-form-field-flex,\n  .comment-field .mdc-text-field {\n    background: transparent !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .users-list .user-option,\n  .page-btn,\n  .pagination-info {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .users-list .user-option,\n  .users-list mat-list-option {\n    --mdc-list-list-item-hover-state-layer-color: rgba(94, 161, 216, 0.12);\n    --mdc-list-list-item-focus-state-layer-color: rgba(94, 161, 216, 0.16);\n    --mdc-list-list-item-hover-state-layer-opacity: 1;\n    --mat-list-list-item-hover-state-layer-color: rgba(94, 161, 216, 0.12);\n  }\n\n  .users-list .user-option:hover,\n  .users-list .user-option:focus,\n  .users-list mat-list-option:hover,\n  .users-list mat-list-option:focus {\n    background: rgba(94, 161, 216, 0.12) !important;\n    color: #e2e8f0 !important;\n  }\n\n  .users-list .user-option .user-name,\n  .users-list .user-option .user-email,\n  .users-list mat-list-option .user-name,\n  .users-list mat-list-option .user-email {\n    color: #e2e8f0 !important;\n  }\n\n  .selected-user-card {\n    background: #1e3a4a !important;\n    border-color: rgba(94, 161, 216, 0.4) !important;\n    color: #e2e8f0 !important;\n  }\n\n  .selected-user-card .user-name {\n    color: #f0f9ff !important;\n  }\n\n  .selected-user-card .user-email {\n    color: #94a3b8 !important;\n  }\n\n  .dialog-actions .cancel-btn {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.4) !important;\n  }\n\n  .dialog-actions .cancel-btn span,\n  .dialog-actions .cancel-btn .mdc-button__label,\n  .dialog-actions .cancel-btn mat-icon {\n    color: #e2e8f0 !important;\n  }\n\n  .dialog-actions .transfer-btn,\n  .dialog-actions .confirm-user-btn {\n    background: #5ea1d8 !important;\n    border-color: #5ea1d8 !important;\n    color: #ffffff !important;\n  }\n\n  .dialog-actions .transfer-btn span,\n  .dialog-actions .confirm-user-btn span,\n  .dialog-actions .transfer-btn .mdc-button__label,\n  .dialog-actions .confirm-user-btn .mdc-button__label,\n  .dialog-actions .transfer-btn mat-icon,\n  .dialog-actions .confirm-user-btn mat-icon {\n    color: #ffffff !important;\n  }\n\n  .ownership-warning,\n  .ownership-warning .note-box {\n    background: rgba(120, 53, 15, 0.3) !important;\n    color: #fde68a !important;\n    border-color: rgba(251, 191, 36, 0.45) !important;\n  }\n}\n\n:host-context(body.theme-dark) {\n  .transfer-ownership-dialog,\n  .box,\n  .analytics-header,\n  .analytics-content,\n  .dialog-content,\n  .dialog-actions,\n  .des-box,\n  .des-box:after {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .dialog-actions {\n    background: #0f172a !important;\n  }\n\n  .search-input,\n  .search-input-wrapper .search-input,\n  .mat-mdc-form-field .mat-mdc-text-field-wrapper {\n    background: #1f2937 !important;\n    color: #f8fafc !important;\n    border-color: rgba(148, 163, 184, 0.45) !important;\n  }\n\n  .comment-field textarea,\n  .comment-field .mat-mdc-text-field-wrapper,\n  .comment-field .mat-mdc-form-field-flex,\n  .comment-field .mdc-text-field {\n    background: transparent !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .page-btn,\n  .users-list .user-option {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  // Override Angular Material state-layer (hover overlay) for mat-list-option\n  .users-list .user-option,\n  .users-list mat-list-option {\n    --mdc-list-list-item-hover-state-layer-color: rgba(94, 161, 216, 0.12);\n    --mdc-list-list-item-focus-state-layer-color: rgba(94, 161, 216, 0.16);\n    --mdc-list-list-item-hover-state-layer-opacity: 1;\n    --mat-list-list-item-hover-state-layer-color: rgba(94, 161, 216, 0.12);\n  }\n\n  .users-list .user-option:hover,\n  .users-list .user-option:focus,\n  .users-list mat-list-option:hover,\n  .users-list mat-list-option:focus {\n    background: rgba(94, 161, 216, 0.12) !important;\n    color: #e2e8f0 !important;\n  }\n\n  .users-list .user-option .user-name,\n  .users-list .user-option .user-email,\n  .users-list mat-list-option .user-name,\n  .users-list mat-list-option .user-email {\n    color: #e2e8f0 !important;\n  }\n\n  .selected-user-card {\n    background: #1e3a4a !important;\n    border-color: rgba(94, 161, 216, 0.4) !important;\n    color: #e2e8f0 !important;\n  }\n\n  .selected-user-card .user-name {\n    color: #f0f9ff !important;\n  }\n\n  .selected-user-card .user-email {\n    color: #94a3b8 !important;\n  }\n\n  .comment-form-section {\n    background: transparent !important;\n    border-color: rgba(148, 163, 184, 0.2) !important;\n  }\n\n  .user-name,\n  .user-email,\n  .section-header h3,\n  .pagination-info,\n  .char-count,\n  .search-icon,\n  .close-ico,\n  .close-ico .close-icon {\n    color: #e2e8f0 !important;\n  }\n\n  .ownership-warning,\n  .ownership-warning .note-box {\n    background: rgba(120, 53, 15, 0.3) !important;\n    color: #fde68a !important;\n    border-color: rgba(251, 191, 36, 0.45) !important;\n  }\n\n  .dialog-actions .cancel-btn {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.4) !important;\n  }\n\n  .dialog-actions .cancel-btn span,\n  .dialog-actions .cancel-btn .mdc-button__label,\n  .dialog-actions .cancel-btn mat-icon {\n    color: #e2e8f0 !important;\n  }\n\n  .dialog-actions .transfer-btn,\n  .dialog-actions .confirm-user-btn {\n    background: #5ea1d8 !important;\n    border-color: #5ea1d8 !important;\n    color: #ffffff !important;\n  }\n\n  .dialog-actions .transfer-btn span,\n  .dialog-actions .confirm-user-btn span,\n  .dialog-actions .transfer-btn .mdc-button__label,\n  .dialog-actions .confirm-user-btn .mdc-button__label,\n  .dialog-actions .transfer-btn mat-icon,\n  .dialog-actions .confirm-user-btn mat-icon {\n    color: #ffffff !important;\n  }\n\n  .dialog-actions .transfer-btn:disabled,\n  .dialog-actions .confirm-user-btn:disabled {\n    background: #374151 !important;\n    border-color: #374151 !important;\n    color: #6b7280 !important;\n  }\n\n  .dialog-actions .transfer-btn:disabled span,\n  .dialog-actions .confirm-user-btn:disabled span,\n  .dialog-actions .transfer-btn:disabled .mdc-button__label,\n  .dialog-actions .confirm-user-btn:disabled .mdc-button__label,\n  .dialog-actions .transfer-btn:disabled mat-icon,\n  .dialog-actions .confirm-user-btn:disabled mat-icon {\n    color: #6b7280 !important;\n  }\n\n  .avatar-placeholder {\n    background: transparent !important;\n    color: #94a3b8 !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .transfer-ownership-dialog {\n    max-height: 95vh !important;\n    width: 98vw !important;\n    max-width: 98vw !important;\n    margin: 2.5vh auto !important;\n    border-radius: 6px;\n    position: relative !important;\n    top: auto !important;\n    left: auto !important;\n    transform: none !important;\n    -webkit-overflow-scrolling: touch;\n\n    .dialog-header {\n      padding: 12px 0px;\n      min-height: 56px;\n\n      h2 {\n        font-size: 16px;\n        line-height: 1.3;\n      }\n\n      .close-button {\n        min-width: 44px;\n        min-height: 44px;\n        padding: 10px;\n        background: transparent !important;\n        border: none !important;\n        box-shadow: none !important;\n      }\n    }\n\n    .dialog-content {\n      padding: 16px;\n      max-height: calc(98vh - 120px);\n      overflow-y: auto;\n      -webkit-overflow-scrolling: touch;\n\n      .search-section {\n        .search-input {\n          min-height: 44px;\n          font-size: 16px;\n          padding: 10px 14px;\n        }\n      }\n\n      .users-section {\n        .users-list {\n          .user-option {\n            min-height: 56px;\n            padding: 10px 14px;\n\n            .user-item {\n              .user-avatar {\n                .avatar-image,\n                .avatar-placeholder {\n                  width: 44px;\n                  height: 44px;\n                }\n              }\n\n              .user-info {\n                .user-name {\n                  font-size: 15px;\n                }\n              }\n            }\n          }\n        }\n\n        .pagination-controls {\n          .nav-btn {\n            min-width: 44px; // Maintain WCAG minimum\n            min-height: 44px;\n            padding: 6px;\n\n            mat-icon {\n              font-size: 16px;\n              width: 16px;\n              height: 16px;\n            }\n          }\n\n          .page-numbers {\n            .page-btn {\n              min-width: 44px; // Maintain WCAG minimum\n              min-height: 44px;\n              font-size: 12px;\n              padding: 6px 10px;\n            }\n          }\n        }\n      }\n\n      .selected-user-section {\n        .selected-user-card {\n          padding: 14px;\n\n          .user-avatar {\n            .avatar-image,\n            .avatar-placeholder {\n              width: 52px;\n              height: 52px;\n            }\n          }\n\n          .user-info {\n            .user-name {\n              font-size: 16px;\n            }\n\n            .user-email {\n              font-size: 13px;\n            }\n          }\n        }\n      }\n\n      .ownership-warning {\n        .note-box {\n          padding: 14px;\n          font-size: 13px;\n\n          .note-list {\n            padding-left: 18px;\n\n            li {\n              margin-bottom: 6px;\n            }\n          }\n        }\n      }\n\n      .comment-form-section {\n        .form-header {\n          h4 {\n            font-size: 15px;\n          }\n\n          .char-count {\n            font-size: 11px;\n          }\n        }\n\n        .comment-field {\n          .mat-mdc-form-field {\n            .mat-mdc-text-field-wrapper {\n              .mat-mdc-form-field-flex {\n                .mat-mdc-form-field-infix {\n                  textarea {\n                    min-height: 70px;\n                    font-size: 16px;\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n\n    .dialog-actions {\n      padding: 12px 16px;\n      min-height: 56px;\n      position: sticky;\n      bottom: 0;\n      background: #f8f9fa;\n      border-top: 1px solid #e0e0e0;\n      display: flex;\n      gap: 8px;\n      justify-content: flex-end;\n\n      .cancel-btn,\n      .transfer-btn,\n      .confirm-user-btn {\n        min-height: 44px; // Maintain WCAG minimum\n        min-width: 100px;\n        font-size: 13px;\n        padding: 10px 16px;\n\n        mat-icon {\n          font-size: 16px;\n          width: 16px;\n          height: 16px;\n          margin-right: 6px;\n        }\n      }\n    }\n  }\n}\n\n/* Mobile-specific dialog improvements */\n@media (max-width: 768px) {\n  .mat-mdc-dialog-container {\n    padding: 0 !important;\n    margin: 0 !important;\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n  }\n\n  .mat-mdc-dialog-surface {\n    padding: 0 !important;\n    margin: 0 !important;\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n  }\n\n  .cdk-overlay-pane {\n    max-width: 100vw !important;\n    max-height: 100vh !important;\n  }\n}\n\n/* Additional mobile accessibility improvements */\n@media (max-width: 768px) {\n  // Improve focus visibility\n  *:focus {\n    outline: 2px solid #5ea1d8 !important;\n    outline-offset: 2px !important;\n  }\n\n  // Better touch feedback\n  .user-option,\n  .nav-btn,\n  .page-btn,\n  .cancel-btn,\n  .transfer-btn,\n  .confirm-user-btn,\n  .change-user-btn {\n    -webkit-tap-highlight-color: rgba(94, 161, 216, 0.2);\n    transition: all 0.2s ease;\n  }\n\n  // Prevent text selection on interactive elements\n  .nav-btn,\n  .page-btn,\n  .cancel-btn,\n  .transfer-btn,\n  .confirm-user-btn,\n  .change-user-btn {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n  }\n\n  // Improve scroll behavior\n  .dialog-content {\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  // Better visual hierarchy\n  .transfer-ownership-dialog {\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n    border: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  // Improve loading states\n  .searching-users {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 20px;\n    color: #666;\n    font-size: 14px;\n\n    mat-spinner {\n      margin-right: 8px;\n    }\n  }\n\n  .no-users {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 40px 20px;\n    color: #666;\n    font-size: 14px;\n\n    mat-icon {\n      font-size: 48px;\n      width: 48px;\n      height: 48px;\n      color: #ccc;\n    }\n  }\n\n  // Improve form field accessibility\n  .mat-mdc-form-field {\n    .mat-mdc-text-field-wrapper {\n      .mat-mdc-form-field-flex {\n        .mat-mdc-form-field-infix {\n          input,\n          textarea {\n            -webkit-appearance: none;\n            appearance: none;\n            border-radius: 0;\n          }\n        }\n      }\n    }\n  }\n\n  // Better button states\n  .user-option {\n    &:hover,\n    &:focus {\n      background-color: #f0f8ff;\n      transform: translateY(-1px);\n      box-shadow: 0 2px 8px rgba(94, 161, 216, 0.15);\n    }\n\n    &.mat-mdc-list-option-selected {\n      background-color: #e3f2fd;\n      border-left: 4px solid #5ea1d8;\n    }\n  }\n\n  // Improve pagination visibility\n  .pagination-controls {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 16px 0;\n    border-top: 1px solid #e0e0e0;\n    margin-top: 16px;\n\n    .page-numbers {\n      display: flex;\n      gap: 4px;\n      flex-wrap: wrap;\n      justify-content: center;\n    }\n  }\n\n  // Better progress bar\n  .progress-bar {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 3px;\n    background: linear-gradient(90deg, #5ea1d8, #4a8bc2);\n    border-radius: 0;\n  }\n}\n\n/* Transfer Ownership Component - Clean Styles */\n\n/* Container and Layout */\n.container {\n  padding: 0px !important;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.box {\n  width: 100% !important;\n  max-width: 800px;\n  min-width: 500px;\n  margin: 16px auto;\n  padding: 0;\n  background: #fff;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 35px 70px rgba(7, 8, 10, 0.35);\n  overflow: hidden;\n  border-radius: 22px;\n}\n\n.box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 20px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.des-box {\n  background: #fff;\n  position: relative;\n  width: 100%;\n}\n\n/* Header Styles */\n.analytics-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  background: #fff !important;\n  color: #333;\n  border-bottom: 1px solid #e0e0e0;\n  position: relative; // ensure absolutely positioned close button anchors to header\n\n  h2 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  .header-icon {\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    color: #333;\n    background: transparent !important;\n    border: none !important;\n    box-shadow: none;\n  }\n}\n\n.close-ico {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  color: #666;\n  opacity: 1 !important;\n  z-index: 10;\n  cursor: pointer;\n  background: transparent;\n  border: none;\n}\n\n.close-ico .close-icon {\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n}\n\n/* Content Styles */\n.analytics-content {\n  flex: 1;\n  overflow-y: auto;\n  background: #fff !important;\n}\n\n.dialog-content {\n  padding: 24px;\n}\n\n/* Search Section */\n.search-section {\n  margin-bottom: 24px;\n\n  .search-input-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n\n    .search-icon {\n      position: absolute;\n      left: 12px;\n      color: #666;\n      z-index: 1;\n    }\n\n    .search-input {\n      width: 100%;\n      padding: 12px 12px 12px 44px;\n      border: 2px solid #e0e0e0;\n      border-radius: 8px;\n      font-size: 14px;\n      transition: border-color 0.2s ease;\n\n      &:focus {\n        outline: none;\n        border-color: #5ea1d8;\n        box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);\n      }\n\n      &::placeholder {\n        color: #999;\n      }\n    }\n  }\n}\n\n/* Users Section */\n.users-section {\n  .section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n\n    h3 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #333;\n    }\n\n    .pagination-info {\n      font-size: 12px;\n      color: #666;\n      background: #f5f5f5;\n      padding: 4px 8px;\n      border-radius: 12px;\n    }\n  }\n\n  .searching-users {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 32px;\n    color: #666;\n  }\n\n  .no-users {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 32px;\n    color: #999;\n  }\n\n  .users-list {\n    margin-bottom: 16px;\n\n    .user-option {\n      border-radius: 8px;\n      margin-bottom: 8px;\n      transition: background-color 0.2s ease;\n\n      &:hover {\n        background-color: #f8f9fa;\n      }\n    }\n\n    .user-item {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      padding: 8px 12px;\n      min-width: 0;\n    }\n\n    .user-avatar {\n      width: 40px;\n      height: 40px;\n      border-radius: 50%;\n      overflow: hidden;\n      flex-shrink: 0;\n    }\n\n    .avatar-image {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    .avatar-placeholder {\n      width: 100%;\n      height: 100%;\n      background: linear-gradient(135deg, #5ea1d8 0%, #56baed 100%);\n      color: #fff;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 16px;\n      font-weight: 600;\n    }\n\n    .user-info {\n      flex: 1;\n      min-width: 0;\n    }\n\n    .user-name {\n      font-weight: 600;\n      color: #333;\n      margin-bottom: 2px;\n      font-size: 14px;\n    }\n\n    .user-email {\n      color: #666;\n      font-size: 12px;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .pagination-controls {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 16px;\n  }\n\n  .nav-btn {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:hover {\n      background: #f5f5f5;\n    }\n\n    &:disabled:hover {\n      background: transparent;\n    }\n  }\n\n  .page-numbers {\n    display: flex;\n    gap: 4px;\n  }\n\n  .page-btn {\n    min-width: 32px;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: 500;\n    border: 1px solid #e0e0e0;\n    background: #fff;\n    color: #666;\n    transition: all 0.2s ease;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    &:hover:not(:disabled) {\n      background: #f5f5f5;\n      border-color: #ccc;\n    }\n\n    &.active {\n      background: #5ea1d8;\n      color: #fff;\n      border-color: #5ea1d8;\n    }\n  }\n}\n\n/* Selected User Section */\n.selected-user-section {\n  .selected-user-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 16px;\n\n    h3 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #333;\n    }\n  }\n\n  .selected-user-card {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 16px;\n    background: #f8f9fa;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n\n    .user-avatar {\n      width: 48px;\n      height: 48px;\n      border-radius: 50%;\n      overflow: hidden;\n      flex-shrink: 0;\n    }\n\n    .avatar-image {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    .avatar-placeholder {\n      width: 100%;\n      height: 100%;\n      background: linear-gradient(135deg, #f5f5f5 0%, #f5f5f5 100%);\n      color: #fff;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 18px;\n      font-weight: 600;\n    }\n\n    .user-info {\n      flex: 1;\n\n      .user-name {\n        font-weight: 600;\n        color: #333;\n        margin-bottom: 4px;\n        font-size: 16px;\n      }\n\n      .user-email {\n        color: #666;\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n/* Ownership Warning */\n.ownership-warning {\n  margin-bottom: 20px;\n\n  .note-box {\n    background: #fff3cd;\n    border: 1px solid #ffeaa7;\n    border-radius: 8px;\n    padding: 16px;\n    font-size: 14px;\n    color: #856404;\n\n    .note-list {\n      margin: 12px 0 0 0;\n      padding-left: 20px;\n\n      li {\n        margin-bottom: 8px;\n      }\n    }\n  }\n}\n\n/* Comment Form Section */\n.comment-form-section {\n  margin-bottom: 20px;\n\n  .form-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n\n    h4 {\n      margin: 0;\n      font-size: 16px;\n      font-weight: 600;\n      color: #333;\n    }\n\n    .char-count {\n      font-size: 12px;\n      color: #666;\n    }\n  }\n\n  .comment-field {\n    width: 100%;\n  }\n}\n\n/* Dialog Actions */\n.dialog-actions {\n  padding: 16px 20px;\n  min-height: 60px;\n  position: sticky;\n  bottom: 0;\n  background: #f8f9fa;\n  border-top: 1px solid #e0e0e0;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  align-items: flex-end;\n\n  .cancel-btn,\n  .transfer-btn,\n  .confirm-user-btn {\n    min-height: 48px;\n    min-width: 120px;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 6px;\n    padding: 12px 20px;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      margin-right: 8px;\n    }\n  }\n\n  .cancel-btn {\n    background: #f5f5f5;\n    color: #666;\n    border: 1px solid #ddd;\n\n    &:hover {\n      background: #e8e8e8;\n    }\n  }\n\n  .transfer-btn,\n  .confirm-user-btn {\n    background: #5ea1d8;\n    color: white;\n\n    &:hover:not(:disabled) {\n      background: #4a8bc2;\n    }\n\n    &:disabled {\n      background: #ccc;\n      color: #999;\n    }\n  }\n}\n\n/* Progress Bar */\n.progress-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .box {\n    max-width: 100% !important;\n    min-width: auto;\n    margin: 8px;\n    padding: 0;\n    border-radius: 16px;\n  }\n\n  .close-ico {\n    top: 16px !important; // keep icon inside header on small screens\n    right: 20px;\n  }\n\n  .dialog-content {\n    padding: 16px;\n  }\n\n  .dialog-actions {\n    padding: 12px 16px;\n    min-height: 56px;\n    gap: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n\n    .cancel-btn,\n    .transfer-btn,\n    .confirm-user-btn {\n      min-height: 44px;\n      min-width: 100px;\n      font-size: 13px;\n      padding: 10px 16px;\n\n      mat-icon {\n        font-size: 16px;\n        width: 16px;\n        height: 16px;\n        margin-right: 6px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
